import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  pairing_status: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
  vector: { input: any; output: any; }
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface Boolean_Comparison_Exp {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface Int_Comparison_Exp {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface String_Array_Comparison_Exp {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface String_Comparison_Exp {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
}

/** columns and relationships of "conversations" */
export interface Conversations {
  __typename?: 'conversations';
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}


/** columns and relationships of "conversations" */
export interface ConversationsMessagesArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


/** columns and relationships of "conversations" */
export interface ConversationsMessages_AggregateArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}

/** aggregated selection of "conversations" */
export interface Conversations_Aggregate {
  __typename?: 'conversations_aggregate';
  aggregate?: Maybe<Conversations_Aggregate_Fields>;
  nodes: Array<Conversations>;
}

export interface Conversations_Aggregate_Bool_Exp {
  count?: InputMaybe<Conversations_Aggregate_Bool_Exp_Count>;
}

export interface Conversations_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Conversations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Conversations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "conversations" */
export interface Conversations_Aggregate_Fields {
  __typename?: 'conversations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Conversations_Max_Fields>;
  min?: Maybe<Conversations_Min_Fields>;
}


/** aggregate fields of "conversations" */
export interface Conversations_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Conversations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "conversations" */
export interface Conversations_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Conversations_Max_Order_By>;
  min?: InputMaybe<Conversations_Min_Order_By>;
}

/** input type for inserting array relation for remote table "conversations" */
export interface Conversations_Arr_Rel_Insert_Input {
  data: Array<Conversations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Conversations_On_Conflict>;
}

/** Boolean expression to filter rows from the table "conversations". All fields are combined with a logical 'AND'. */
export interface Conversations_Bool_Exp {
  _and?: InputMaybe<Array<Conversations_Bool_Exp>>;
  _not?: InputMaybe<Conversations_Bool_Exp>;
  _or?: InputMaybe<Array<Conversations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  messages?: InputMaybe<Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "conversations" */
export type Conversations_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'conversations_pkey';

/** input type for inserting data into table "conversations" */
export interface Conversations_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Conversations_Max_Fields {
  __typename?: 'conversations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "conversations" */
export interface Conversations_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Conversations_Min_Fields {
  __typename?: 'conversations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "conversations" */
export interface Conversations_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "conversations" */
export interface Conversations_Mutation_Response {
  __typename?: 'conversations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Conversations>;
}

/** input type for inserting object relation for remote table "conversations" */
export interface Conversations_Obj_Rel_Insert_Input {
  data: Conversations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Conversations_On_Conflict>;
}

/** on_conflict condition type for table "conversations" */
export interface Conversations_On_Conflict {
  constraint: Conversations_Constraint;
  update_columns?: Array<Conversations_Update_Column>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}

/** Ordering options when selecting data from "conversations". */
export interface Conversations_Order_By {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: conversations */
export interface Conversations_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "conversations" */
export type Conversations_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'id'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "conversations" */
export interface Conversations_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "conversations" */
export interface Conversations_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Conversations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Conversations_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "conversations" */
export type Conversations_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'id'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Conversations_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Conversations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Conversations_Bool_Exp;
}

/** ordering argument of a cursor */
export type Cursor_Ordering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC';

export interface Jsonb_Cast_Exp {
  String?: InputMaybe<String_Comparison_Exp>;
}

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export interface Jsonb_Comparison_Exp {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
}

/** columns and relationships of "menus" */
export interface Menus {
  __typename?: 'menus';
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  pairing?: Maybe<Pairings>;
  pairing_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}

/** aggregated selection of "menus" */
export interface Menus_Aggregate {
  __typename?: 'menus_aggregate';
  aggregate?: Maybe<Menus_Aggregate_Fields>;
  nodes: Array<Menus>;
}

export interface Menus_Aggregate_Bool_Exp {
  count?: InputMaybe<Menus_Aggregate_Bool_Exp_Count>;
}

export interface Menus_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Menus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Menus_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "menus" */
export interface Menus_Aggregate_Fields {
  __typename?: 'menus_aggregate_fields';
  avg?: Maybe<Menus_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Menus_Max_Fields>;
  min?: Maybe<Menus_Min_Fields>;
  stddev?: Maybe<Menus_Stddev_Fields>;
  stddev_pop?: Maybe<Menus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Menus_Stddev_Samp_Fields>;
  sum?: Maybe<Menus_Sum_Fields>;
  var_pop?: Maybe<Menus_Var_Pop_Fields>;
  var_samp?: Maybe<Menus_Var_Samp_Fields>;
  variance?: Maybe<Menus_Variance_Fields>;
}


/** aggregate fields of "menus" */
export interface Menus_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Menus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "menus" */
export interface Menus_Aggregate_Order_By {
  avg?: InputMaybe<Menus_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Menus_Max_Order_By>;
  min?: InputMaybe<Menus_Min_Order_By>;
  stddev?: InputMaybe<Menus_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Menus_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Menus_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Menus_Sum_Order_By>;
  var_pop?: InputMaybe<Menus_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Menus_Var_Samp_Order_By>;
  variance?: InputMaybe<Menus_Variance_Order_By>;
}

/** input type for inserting array relation for remote table "menus" */
export interface Menus_Arr_Rel_Insert_Input {
  data: Array<Menus_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Menus_On_Conflict>;
}

/** aggregate avg on columns */
export interface Menus_Avg_Fields {
  __typename?: 'menus_avg_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by avg() on columns of table "menus" */
export interface Menus_Avg_Order_By {
  price?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "menus". All fields are combined with a logical 'AND'. */
export interface Menus_Bool_Exp {
  _and?: InputMaybe<Array<Menus_Bool_Exp>>;
  _not?: InputMaybe<Menus_Bool_Exp>;
  _or?: InputMaybe<Array<Menus_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pairing?: InputMaybe<Pairings_Bool_Exp>;
  pairing_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "menus" */
export type Menus_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'menus_pkey';

/** input type for incrementing numeric columns in table "menus" */
export interface Menus_Inc_Input {
  price?: InputMaybe<Scalars['numeric']['input']>;
}

/** input type for inserting data into table "menus" */
export interface Menus_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pairing?: InputMaybe<Pairings_Obj_Rel_Insert_Input>;
  pairing_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Menus_Max_Fields {
  __typename?: 'menus_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pairing_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "menus" */
export interface Menus_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pairing_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Menus_Min_Fields {
  __typename?: 'menus_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pairing_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "menus" */
export interface Menus_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pairing_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "menus" */
export interface Menus_Mutation_Response {
  __typename?: 'menus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Menus>;
}

/** on_conflict condition type for table "menus" */
export interface Menus_On_Conflict {
  constraint: Menus_Constraint;
  update_columns?: Array<Menus_Update_Column>;
  where?: InputMaybe<Menus_Bool_Exp>;
}

/** Ordering options when selecting data from "menus". */
export interface Menus_Order_By {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pairing?: InputMaybe<Pairings_Order_By>;
  pairing_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: menus */
export interface Menus_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "menus" */
export type Menus_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'pairing_id'
  /** column name */
  | 'price'
  /** column name */
  | 'status'
  /** column name */
  | 'tags'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "menus" */
export interface Menus_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pairing_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate stddev on columns */
export interface Menus_Stddev_Fields {
  __typename?: 'menus_stddev_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev() on columns of table "menus" */
export interface Menus_Stddev_Order_By {
  price?: InputMaybe<Order_By>;
}

/** aggregate stddev_pop on columns */
export interface Menus_Stddev_Pop_Fields {
  __typename?: 'menus_stddev_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_pop() on columns of table "menus" */
export interface Menus_Stddev_Pop_Order_By {
  price?: InputMaybe<Order_By>;
}

/** aggregate stddev_samp on columns */
export interface Menus_Stddev_Samp_Fields {
  __typename?: 'menus_stddev_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_samp() on columns of table "menus" */
export interface Menus_Stddev_Samp_Order_By {
  price?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "menus" */
export interface Menus_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Menus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Menus_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pairing_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate sum on columns */
export interface Menus_Sum_Fields {
  __typename?: 'menus_sum_fields';
  price?: Maybe<Scalars['numeric']['output']>;
}

/** order by sum() on columns of table "menus" */
export interface Menus_Sum_Order_By {
  price?: InputMaybe<Order_By>;
}

/** update columns of table "menus" */
export type Menus_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'pairing_id'
  /** column name */
  | 'price'
  /** column name */
  | 'status'
  /** column name */
  | 'tags'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Menus_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Menus_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Menus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Menus_Bool_Exp;
}

/** aggregate var_pop on columns */
export interface Menus_Var_Pop_Fields {
  __typename?: 'menus_var_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by var_pop() on columns of table "menus" */
export interface Menus_Var_Pop_Order_By {
  price?: InputMaybe<Order_By>;
}

/** aggregate var_samp on columns */
export interface Menus_Var_Samp_Fields {
  __typename?: 'menus_var_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by var_samp() on columns of table "menus" */
export interface Menus_Var_Samp_Order_By {
  price?: InputMaybe<Order_By>;
}

/** aggregate variance on columns */
export interface Menus_Variance_Fields {
  __typename?: 'menus_variance_fields';
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by variance() on columns of table "menus" */
export interface Menus_Variance_Order_By {
  price?: InputMaybe<Order_By>;
}

/** columns and relationships of "messages" */
export interface Messages {
  __typename?: 'messages';
  content: Scalars['jsonb']['output'];
  /** An object relationship */
  conversation: Conversations;
  conversation_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message?: Maybe<Messages>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** Message parameters, can store arbitrary JSON data */
  params?: Maybe<Scalars['jsonb']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  role: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
}


/** columns and relationships of "messages" */
export interface MessagesContentArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}


/** columns and relationships of "messages" */
export interface MessagesMessagesArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


/** columns and relationships of "messages" */
export interface MessagesMessages_AggregateArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


/** columns and relationships of "messages" */
export interface MessagesParamsArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}

/** aggregated selection of "messages" */
export interface Messages_Aggregate {
  __typename?: 'messages_aggregate';
  aggregate?: Maybe<Messages_Aggregate_Fields>;
  nodes: Array<Messages>;
}

export interface Messages_Aggregate_Bool_Exp {
  count?: InputMaybe<Messages_Aggregate_Bool_Exp_Count>;
}

export interface Messages_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "messages" */
export interface Messages_Aggregate_Fields {
  __typename?: 'messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messages_Max_Fields>;
  min?: Maybe<Messages_Min_Fields>;
}


/** aggregate fields of "messages" */
export interface Messages_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "messages" */
export interface Messages_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messages_Max_Order_By>;
  min?: InputMaybe<Messages_Min_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Messages_Append_Input {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "messages" */
export interface Messages_Arr_Rel_Insert_Input {
  data: Array<Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
}

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export interface Messages_Bool_Exp {
  _and?: InputMaybe<Array<Messages_Bool_Exp>>;
  _not?: InputMaybe<Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Messages_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  conversation?: InputMaybe<Conversations_Bool_Exp>;
  conversation_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Messages_Bool_Exp>;
  messages?: InputMaybe<Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
  params?: InputMaybe<Jsonb_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
}

/** unique or primary key constraints on table "messages" */
export type Messages_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'messages_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Messages_Delete_At_Path_Input {
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Messages_Delete_Elem_Input {
  content?: InputMaybe<Scalars['Int']['input']>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Messages_Delete_Key_Input {
  content?: InputMaybe<Scalars['String']['input']>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting data into table "messages" */
export interface Messages_Insert_Input {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  conversation?: InputMaybe<Conversations_Obj_Rel_Insert_Input>;
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['jsonb']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** aggregate max on columns */
export interface Messages_Max_Fields {
  __typename?: 'messages_max_fields';
  conversation_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by max() on columns of table "messages" */
export interface Messages_Max_Order_By {
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Messages_Min_Fields {
  __typename?: 'messages_min_fields';
  conversation_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by min() on columns of table "messages" */
export interface Messages_Min_Order_By {
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "messages" */
export interface Messages_Mutation_Response {
  __typename?: 'messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages>;
}

/** input type for inserting object relation for remote table "messages" */
export interface Messages_Obj_Rel_Insert_Input {
  data: Messages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
}

/** on_conflict condition type for table "messages" */
export interface Messages_On_Conflict {
  constraint: Messages_Constraint;
  update_columns?: Array<Messages_Update_Column>;
  where?: InputMaybe<Messages_Bool_Exp>;
}

/** Ordering options when selecting data from "messages". */
export interface Messages_Order_By {
  content?: InputMaybe<Order_By>;
  conversation?: InputMaybe<Conversations_Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Messages_Order_By>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  params?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** primary key columns input for table: messages */
export interface Messages_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Messages_Prepend_Input {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "messages" */
export type Messages_Select_Column =
  /** column name */
  | 'content'
  /** column name */
  | 'conversation_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'params'
  /** column name */
  | 'parent_id'
  /** column name */
  | 'role'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "messages" */
export interface Messages_Set_Input {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['jsonb']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** Streaming cursor of the table "messages" */
export interface Messages_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Messages_Stream_Cursor_Value_Input {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Message parameters, can store arbitrary JSON data */
  params?: InputMaybe<Scalars['jsonb']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** update columns of table "messages" */
export type Messages_Update_Column =
  /** column name */
  | 'content'
  /** column name */
  | 'conversation_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'params'
  /** column name */
  | 'parent_id'
  /** column name */
  | 'role'
  /** column name */
  | 'updated_at';

export interface Messages_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messages_Bool_Exp;
}

/** mutation root */
export interface Mutation_Root {
  __typename?: 'mutation_root';
  /** delete data from the table: "conversations" */
  delete_conversations?: Maybe<Conversations_Mutation_Response>;
  /** delete single row from the table: "conversations" */
  delete_conversations_by_pk?: Maybe<Conversations>;
  /** delete data from the table: "menus" */
  delete_menus?: Maybe<Menus_Mutation_Response>;
  /** delete single row from the table: "menus" */
  delete_menus_by_pk?: Maybe<Menus>;
  /** delete data from the table: "messages" */
  delete_messages?: Maybe<Messages_Mutation_Response>;
  /** delete single row from the table: "messages" */
  delete_messages_by_pk?: Maybe<Messages>;
  /** delete data from the table: "pairing_space.pairing_items" */
  delete_pairing_space_pairing_items?: Maybe<Pairing_Space_Pairing_Items_Mutation_Response>;
  /** delete single row from the table: "pairing_space.pairing_items" */
  delete_pairing_space_pairing_items_by_pk?: Maybe<Pairing_Space_Pairing_Items>;
  /** delete data from the table: "pairing_space.pairings" */
  delete_pairing_space_pairings?: Maybe<Pairing_Space_Pairings_Mutation_Response>;
  /** delete single row from the table: "pairing_space.pairings" */
  delete_pairing_space_pairings_by_pk?: Maybe<Pairing_Space_Pairings>;
  /** delete data from the table: "pairings" */
  delete_pairings?: Maybe<Pairings_Mutation_Response>;
  /** delete single row from the table: "pairings" */
  delete_pairings_by_pk?: Maybe<Pairings>;
  /** delete data from the table: "product_embeddings" */
  delete_product_embeddings?: Maybe<Product_Embeddings_Mutation_Response>;
  /** delete single row from the table: "product_embeddings" */
  delete_product_embeddings_by_pk?: Maybe<Product_Embeddings>;
  /** delete data from the table: "referral_codes" */
  delete_referral_codes?: Maybe<Referral_Codes_Mutation_Response>;
  /** delete single row from the table: "referral_codes" */
  delete_referral_codes_by_pk?: Maybe<Referral_Codes>;
  /** delete data from the table: "refresh_tokens" */
  delete_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** delete single row from the table: "refresh_tokens" */
  delete_refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** delete data from the table: "sources" */
  delete_sources?: Maybe<Sources_Mutation_Response>;
  /** delete single row from the table: "sources" */
  delete_sources_by_pk?: Maybe<Sources>;
  /** delete data from the table: "streamline_image_progress" */
  delete_streamline_image_progress?: Maybe<Streamline_Image_Progress_Mutation_Response>;
  /** delete single row from the table: "streamline_image_progress" */
  delete_streamline_image_progress_by_pk?: Maybe<Streamline_Image_Progress>;
  /** delete data from the table: "streamline_processing_progress" */
  delete_streamline_processing_progress?: Maybe<Streamline_Processing_Progress_Mutation_Response>;
  /** delete single row from the table: "streamline_processing_progress" */
  delete_streamline_processing_progress_by_pk?: Maybe<Streamline_Processing_Progress>;
  /** delete data from the table: "suppliers" */
  delete_suppliers?: Maybe<Suppliers_Mutation_Response>;
  /** delete single row from the table: "suppliers" */
  delete_suppliers_by_pk?: Maybe<Suppliers>;
  /** delete data from the table: "user_api_keys" */
  delete_user_api_keys?: Maybe<User_Api_Keys_Mutation_Response>;
  /** delete single row from the table: "user_api_keys" */
  delete_user_api_keys_by_pk?: Maybe<User_Api_Keys>;
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** delete data from the table: "user_referrals" */
  delete_user_referrals?: Maybe<User_Referrals_Mutation_Response>;
  /** delete single row from the table: "user_referrals" */
  delete_user_referrals_by_pk?: Maybe<User_Referrals>;
  /** delete data from the table: "user_registrations" */
  delete_user_registrations?: Maybe<User_Registrations_Mutation_Response>;
  /** delete single row from the table: "user_registrations" */
  delete_user_registrations_by_pk?: Maybe<User_Registrations>;
  /** delete data from the table: "user_role" */
  delete_user_role?: Maybe<User_Role_Mutation_Response>;
  /** delete single row from the table: "user_role" */
  delete_user_role_by_pk?: Maybe<User_Role>;
  /** delete data from the table: "user_usage" */
  delete_user_usage?: Maybe<User_Usage_Mutation_Response>;
  /** delete single row from the table: "user_usage" */
  delete_user_usage_by_pk?: Maybe<User_Usage>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "verification_codes" */
  delete_verification_codes?: Maybe<Verification_Codes_Mutation_Response>;
  /** delete single row from the table: "verification_codes" */
  delete_verification_codes_by_pk?: Maybe<Verification_Codes>;
  /** delete data from the table: "wine_products" */
  delete_wine_products?: Maybe<Wine_Products_Mutation_Response>;
  /** delete single row from the table: "wine_products" */
  delete_wine_products_by_pk?: Maybe<Wine_Products>;
  /** insert data into the table: "conversations" */
  insert_conversations?: Maybe<Conversations_Mutation_Response>;
  /** insert a single row into the table: "conversations" */
  insert_conversations_one?: Maybe<Conversations>;
  /** insert data into the table: "menus" */
  insert_menus?: Maybe<Menus_Mutation_Response>;
  /** insert a single row into the table: "menus" */
  insert_menus_one?: Maybe<Menus>;
  /** insert data into the table: "messages" */
  insert_messages?: Maybe<Messages_Mutation_Response>;
  /** insert a single row into the table: "messages" */
  insert_messages_one?: Maybe<Messages>;
  /** insert data into the table: "pairing_space.pairing_items" */
  insert_pairing_space_pairing_items?: Maybe<Pairing_Space_Pairing_Items_Mutation_Response>;
  /** insert a single row into the table: "pairing_space.pairing_items" */
  insert_pairing_space_pairing_items_one?: Maybe<Pairing_Space_Pairing_Items>;
  /** insert data into the table: "pairing_space.pairings" */
  insert_pairing_space_pairings?: Maybe<Pairing_Space_Pairings_Mutation_Response>;
  /** insert a single row into the table: "pairing_space.pairings" */
  insert_pairing_space_pairings_one?: Maybe<Pairing_Space_Pairings>;
  /** insert data into the table: "pairings" */
  insert_pairings?: Maybe<Pairings_Mutation_Response>;
  /** insert a single row into the table: "pairings" */
  insert_pairings_one?: Maybe<Pairings>;
  /** insert data into the table: "product_embeddings" */
  insert_product_embeddings?: Maybe<Product_Embeddings_Mutation_Response>;
  /** insert a single row into the table: "product_embeddings" */
  insert_product_embeddings_one?: Maybe<Product_Embeddings>;
  /** insert data into the table: "referral_codes" */
  insert_referral_codes?: Maybe<Referral_Codes_Mutation_Response>;
  /** insert a single row into the table: "referral_codes" */
  insert_referral_codes_one?: Maybe<Referral_Codes>;
  /** insert data into the table: "refresh_tokens" */
  insert_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** insert a single row into the table: "refresh_tokens" */
  insert_refresh_tokens_one?: Maybe<Refresh_Tokens>;
  /** insert data into the table: "sources" */
  insert_sources?: Maybe<Sources_Mutation_Response>;
  /** insert a single row into the table: "sources" */
  insert_sources_one?: Maybe<Sources>;
  /** insert data into the table: "streamline_image_progress" */
  insert_streamline_image_progress?: Maybe<Streamline_Image_Progress_Mutation_Response>;
  /** insert a single row into the table: "streamline_image_progress" */
  insert_streamline_image_progress_one?: Maybe<Streamline_Image_Progress>;
  /** insert data into the table: "streamline_processing_progress" */
  insert_streamline_processing_progress?: Maybe<Streamline_Processing_Progress_Mutation_Response>;
  /** insert a single row into the table: "streamline_processing_progress" */
  insert_streamline_processing_progress_one?: Maybe<Streamline_Processing_Progress>;
  /** insert data into the table: "suppliers" */
  insert_suppliers?: Maybe<Suppliers_Mutation_Response>;
  /** insert a single row into the table: "suppliers" */
  insert_suppliers_one?: Maybe<Suppliers>;
  /** insert data into the table: "user_api_keys" */
  insert_user_api_keys?: Maybe<User_Api_Keys_Mutation_Response>;
  /** insert a single row into the table: "user_api_keys" */
  insert_user_api_keys_one?: Maybe<User_Api_Keys>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "user_referrals" */
  insert_user_referrals?: Maybe<User_Referrals_Mutation_Response>;
  /** insert a single row into the table: "user_referrals" */
  insert_user_referrals_one?: Maybe<User_Referrals>;
  /** insert data into the table: "user_registrations" */
  insert_user_registrations?: Maybe<User_Registrations_Mutation_Response>;
  /** insert a single row into the table: "user_registrations" */
  insert_user_registrations_one?: Maybe<User_Registrations>;
  /** insert data into the table: "user_role" */
  insert_user_role?: Maybe<User_Role_Mutation_Response>;
  /** insert a single row into the table: "user_role" */
  insert_user_role_one?: Maybe<User_Role>;
  /** insert data into the table: "user_usage" */
  insert_user_usage?: Maybe<User_Usage_Mutation_Response>;
  /** insert a single row into the table: "user_usage" */
  insert_user_usage_one?: Maybe<User_Usage>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "verification_codes" */
  insert_verification_codes?: Maybe<Verification_Codes_Mutation_Response>;
  /** insert a single row into the table: "verification_codes" */
  insert_verification_codes_one?: Maybe<Verification_Codes>;
  /** insert data into the table: "wine_products" */
  insert_wine_products?: Maybe<Wine_Products_Mutation_Response>;
  /** insert a single row into the table: "wine_products" */
  insert_wine_products_one?: Maybe<Wine_Products>;
  /** update data of the table: "conversations" */
  update_conversations?: Maybe<Conversations_Mutation_Response>;
  /** update single row of the table: "conversations" */
  update_conversations_by_pk?: Maybe<Conversations>;
  /** update multiples rows of table: "conversations" */
  update_conversations_many?: Maybe<Array<Maybe<Conversations_Mutation_Response>>>;
  /** update data of the table: "menus" */
  update_menus?: Maybe<Menus_Mutation_Response>;
  /** update single row of the table: "menus" */
  update_menus_by_pk?: Maybe<Menus>;
  /** update multiples rows of table: "menus" */
  update_menus_many?: Maybe<Array<Maybe<Menus_Mutation_Response>>>;
  /** update data of the table: "messages" */
  update_messages?: Maybe<Messages_Mutation_Response>;
  /** update single row of the table: "messages" */
  update_messages_by_pk?: Maybe<Messages>;
  /** update multiples rows of table: "messages" */
  update_messages_many?: Maybe<Array<Maybe<Messages_Mutation_Response>>>;
  /** update data of the table: "pairing_space.pairing_items" */
  update_pairing_space_pairing_items?: Maybe<Pairing_Space_Pairing_Items_Mutation_Response>;
  /** update single row of the table: "pairing_space.pairing_items" */
  update_pairing_space_pairing_items_by_pk?: Maybe<Pairing_Space_Pairing_Items>;
  /** update multiples rows of table: "pairing_space.pairing_items" */
  update_pairing_space_pairing_items_many?: Maybe<Array<Maybe<Pairing_Space_Pairing_Items_Mutation_Response>>>;
  /** update data of the table: "pairing_space.pairings" */
  update_pairing_space_pairings?: Maybe<Pairing_Space_Pairings_Mutation_Response>;
  /** update single row of the table: "pairing_space.pairings" */
  update_pairing_space_pairings_by_pk?: Maybe<Pairing_Space_Pairings>;
  /** update multiples rows of table: "pairing_space.pairings" */
  update_pairing_space_pairings_many?: Maybe<Array<Maybe<Pairing_Space_Pairings_Mutation_Response>>>;
  /** update data of the table: "pairings" */
  update_pairings?: Maybe<Pairings_Mutation_Response>;
  /** update single row of the table: "pairings" */
  update_pairings_by_pk?: Maybe<Pairings>;
  /** update multiples rows of table: "pairings" */
  update_pairings_many?: Maybe<Array<Maybe<Pairings_Mutation_Response>>>;
  /** update data of the table: "product_embeddings" */
  update_product_embeddings?: Maybe<Product_Embeddings_Mutation_Response>;
  /** update single row of the table: "product_embeddings" */
  update_product_embeddings_by_pk?: Maybe<Product_Embeddings>;
  /** update multiples rows of table: "product_embeddings" */
  update_product_embeddings_many?: Maybe<Array<Maybe<Product_Embeddings_Mutation_Response>>>;
  /** update data of the table: "referral_codes" */
  update_referral_codes?: Maybe<Referral_Codes_Mutation_Response>;
  /** update single row of the table: "referral_codes" */
  update_referral_codes_by_pk?: Maybe<Referral_Codes>;
  /** update multiples rows of table: "referral_codes" */
  update_referral_codes_many?: Maybe<Array<Maybe<Referral_Codes_Mutation_Response>>>;
  /** update data of the table: "refresh_tokens" */
  update_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** update single row of the table: "refresh_tokens" */
  update_refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** update multiples rows of table: "refresh_tokens" */
  update_refresh_tokens_many?: Maybe<Array<Maybe<Refresh_Tokens_Mutation_Response>>>;
  /** update data of the table: "sources" */
  update_sources?: Maybe<Sources_Mutation_Response>;
  /** update single row of the table: "sources" */
  update_sources_by_pk?: Maybe<Sources>;
  /** update multiples rows of table: "sources" */
  update_sources_many?: Maybe<Array<Maybe<Sources_Mutation_Response>>>;
  /** update data of the table: "streamline_image_progress" */
  update_streamline_image_progress?: Maybe<Streamline_Image_Progress_Mutation_Response>;
  /** update single row of the table: "streamline_image_progress" */
  update_streamline_image_progress_by_pk?: Maybe<Streamline_Image_Progress>;
  /** update multiples rows of table: "streamline_image_progress" */
  update_streamline_image_progress_many?: Maybe<Array<Maybe<Streamline_Image_Progress_Mutation_Response>>>;
  /** update data of the table: "streamline_processing_progress" */
  update_streamline_processing_progress?: Maybe<Streamline_Processing_Progress_Mutation_Response>;
  /** update single row of the table: "streamline_processing_progress" */
  update_streamline_processing_progress_by_pk?: Maybe<Streamline_Processing_Progress>;
  /** update multiples rows of table: "streamline_processing_progress" */
  update_streamline_processing_progress_many?: Maybe<Array<Maybe<Streamline_Processing_Progress_Mutation_Response>>>;
  /** update data of the table: "suppliers" */
  update_suppliers?: Maybe<Suppliers_Mutation_Response>;
  /** update single row of the table: "suppliers" */
  update_suppliers_by_pk?: Maybe<Suppliers>;
  /** update multiples rows of table: "suppliers" */
  update_suppliers_many?: Maybe<Array<Maybe<Suppliers_Mutation_Response>>>;
  /** update data of the table: "user_api_keys" */
  update_user_api_keys?: Maybe<User_Api_Keys_Mutation_Response>;
  /** update single row of the table: "user_api_keys" */
  update_user_api_keys_by_pk?: Maybe<User_Api_Keys>;
  /** update multiples rows of table: "user_api_keys" */
  update_user_api_keys_many?: Maybe<Array<Maybe<User_Api_Keys_Mutation_Response>>>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>;
  /** update data of the table: "user_referrals" */
  update_user_referrals?: Maybe<User_Referrals_Mutation_Response>;
  /** update single row of the table: "user_referrals" */
  update_user_referrals_by_pk?: Maybe<User_Referrals>;
  /** update multiples rows of table: "user_referrals" */
  update_user_referrals_many?: Maybe<Array<Maybe<User_Referrals_Mutation_Response>>>;
  /** update data of the table: "user_registrations" */
  update_user_registrations?: Maybe<User_Registrations_Mutation_Response>;
  /** update single row of the table: "user_registrations" */
  update_user_registrations_by_pk?: Maybe<User_Registrations>;
  /** update multiples rows of table: "user_registrations" */
  update_user_registrations_many?: Maybe<Array<Maybe<User_Registrations_Mutation_Response>>>;
  /** update data of the table: "user_role" */
  update_user_role?: Maybe<User_Role_Mutation_Response>;
  /** update single row of the table: "user_role" */
  update_user_role_by_pk?: Maybe<User_Role>;
  /** update multiples rows of table: "user_role" */
  update_user_role_many?: Maybe<Array<Maybe<User_Role_Mutation_Response>>>;
  /** update data of the table: "user_usage" */
  update_user_usage?: Maybe<User_Usage_Mutation_Response>;
  /** update single row of the table: "user_usage" */
  update_user_usage_by_pk?: Maybe<User_Usage>;
  /** update multiples rows of table: "user_usage" */
  update_user_usage_many?: Maybe<Array<Maybe<User_Usage_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "verification_codes" */
  update_verification_codes?: Maybe<Verification_Codes_Mutation_Response>;
  /** update single row of the table: "verification_codes" */
  update_verification_codes_by_pk?: Maybe<Verification_Codes>;
  /** update multiples rows of table: "verification_codes" */
  update_verification_codes_many?: Maybe<Array<Maybe<Verification_Codes_Mutation_Response>>>;
  /** update data of the table: "wine_products" */
  update_wine_products?: Maybe<Wine_Products_Mutation_Response>;
  /** update single row of the table: "wine_products" */
  update_wine_products_by_pk?: Maybe<Wine_Products>;
  /** update multiples rows of table: "wine_products" */
  update_wine_products_many?: Maybe<Array<Maybe<Wine_Products_Mutation_Response>>>;
}


/** mutation root */
export interface Mutation_RootDelete_ConversationsArgs {
  where: Conversations_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Conversations_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_MenusArgs {
  where: Menus_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Menus_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_MessagesArgs {
  where: Messages_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Messages_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Pairing_Space_Pairing_ItemsArgs {
  where: Pairing_Space_Pairing_Items_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Pairing_Space_Pairing_Items_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Pairing_Space_PairingsArgs {
  where: Pairing_Space_Pairings_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Pairing_Space_Pairings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_PairingsArgs {
  where: Pairings_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Pairings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Product_EmbeddingsArgs {
  where: Product_Embeddings_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Product_Embeddings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Referral_CodesArgs {
  where: Referral_Codes_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Referral_Codes_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Refresh_TokensArgs {
  where: Refresh_Tokens_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Refresh_Tokens_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_SourcesArgs {
  where: Sources_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Sources_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Streamline_Image_ProgressArgs {
  where: Streamline_Image_Progress_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Streamline_Image_Progress_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Streamline_Processing_ProgressArgs {
  where: Streamline_Processing_Progress_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Streamline_Processing_Progress_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_SuppliersArgs {
  where: Suppliers_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Suppliers_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_User_Api_KeysArgs {
  where: User_Api_Keys_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_User_Api_Keys_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_User_ProfilesArgs {
  where: User_Profiles_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_User_Profiles_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_User_ReferralsArgs {
  where: User_Referrals_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_User_Referrals_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_User_RegistrationsArgs {
  where: User_Registrations_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_User_Registrations_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_User_RoleArgs {
  where: User_Role_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_User_Role_By_PkArgs {
  value: Scalars['String']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_User_UsageArgs {
  where: User_Usage_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_User_Usage_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_UsersArgs {
  where: Users_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Users_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Verification_CodesArgs {
  where: Verification_Codes_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Verification_Codes_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootDelete_Wine_ProductsArgs {
  where: Wine_Products_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootDelete_Wine_Products_By_PkArgs {
  id: Scalars['uuid']['input'];
}


/** mutation root */
export interface Mutation_RootInsert_ConversationsArgs {
  objects: Array<Conversations_Insert_Input>;
  on_conflict?: InputMaybe<Conversations_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Conversations_OneArgs {
  object: Conversations_Insert_Input;
  on_conflict?: InputMaybe<Conversations_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_MenusArgs {
  objects: Array<Menus_Insert_Input>;
  on_conflict?: InputMaybe<Menus_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Menus_OneArgs {
  object: Menus_Insert_Input;
  on_conflict?: InputMaybe<Menus_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_MessagesArgs {
  objects: Array<Messages_Insert_Input>;
  on_conflict?: InputMaybe<Messages_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Messages_OneArgs {
  object: Messages_Insert_Input;
  on_conflict?: InputMaybe<Messages_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Pairing_Space_Pairing_ItemsArgs {
  objects: Array<Pairing_Space_Pairing_Items_Insert_Input>;
  on_conflict?: InputMaybe<Pairing_Space_Pairing_Items_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Pairing_Space_Pairing_Items_OneArgs {
  object: Pairing_Space_Pairing_Items_Insert_Input;
  on_conflict?: InputMaybe<Pairing_Space_Pairing_Items_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Pairing_Space_PairingsArgs {
  objects: Array<Pairing_Space_Pairings_Insert_Input>;
  on_conflict?: InputMaybe<Pairing_Space_Pairings_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Pairing_Space_Pairings_OneArgs {
  object: Pairing_Space_Pairings_Insert_Input;
  on_conflict?: InputMaybe<Pairing_Space_Pairings_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_PairingsArgs {
  objects: Array<Pairings_Insert_Input>;
  on_conflict?: InputMaybe<Pairings_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Pairings_OneArgs {
  object: Pairings_Insert_Input;
  on_conflict?: InputMaybe<Pairings_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Product_EmbeddingsArgs {
  objects: Array<Product_Embeddings_Insert_Input>;
  on_conflict?: InputMaybe<Product_Embeddings_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Product_Embeddings_OneArgs {
  object: Product_Embeddings_Insert_Input;
  on_conflict?: InputMaybe<Product_Embeddings_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Referral_CodesArgs {
  objects: Array<Referral_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Referral_Codes_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Referral_Codes_OneArgs {
  object: Referral_Codes_Insert_Input;
  on_conflict?: InputMaybe<Referral_Codes_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Refresh_TokensArgs {
  objects: Array<Refresh_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Refresh_Tokens_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Refresh_Tokens_OneArgs {
  object: Refresh_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Refresh_Tokens_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_SourcesArgs {
  objects: Array<Sources_Insert_Input>;
  on_conflict?: InputMaybe<Sources_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Sources_OneArgs {
  object: Sources_Insert_Input;
  on_conflict?: InputMaybe<Sources_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Streamline_Image_ProgressArgs {
  objects: Array<Streamline_Image_Progress_Insert_Input>;
  on_conflict?: InputMaybe<Streamline_Image_Progress_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Streamline_Image_Progress_OneArgs {
  object: Streamline_Image_Progress_Insert_Input;
  on_conflict?: InputMaybe<Streamline_Image_Progress_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Streamline_Processing_ProgressArgs {
  objects: Array<Streamline_Processing_Progress_Insert_Input>;
  on_conflict?: InputMaybe<Streamline_Processing_Progress_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Streamline_Processing_Progress_OneArgs {
  object: Streamline_Processing_Progress_Insert_Input;
  on_conflict?: InputMaybe<Streamline_Processing_Progress_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_SuppliersArgs {
  objects: Array<Suppliers_Insert_Input>;
  on_conflict?: InputMaybe<Suppliers_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Suppliers_OneArgs {
  object: Suppliers_Insert_Input;
  on_conflict?: InputMaybe<Suppliers_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Api_KeysArgs {
  objects: Array<User_Api_Keys_Insert_Input>;
  on_conflict?: InputMaybe<User_Api_Keys_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Api_Keys_OneArgs {
  object: User_Api_Keys_Insert_Input;
  on_conflict?: InputMaybe<User_Api_Keys_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_ProfilesArgs {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Profiles_OneArgs {
  object: User_Profiles_Insert_Input;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_ReferralsArgs {
  objects: Array<User_Referrals_Insert_Input>;
  on_conflict?: InputMaybe<User_Referrals_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Referrals_OneArgs {
  object: User_Referrals_Insert_Input;
  on_conflict?: InputMaybe<User_Referrals_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_RegistrationsArgs {
  objects: Array<User_Registrations_Insert_Input>;
  on_conflict?: InputMaybe<User_Registrations_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Registrations_OneArgs {
  object: User_Registrations_Insert_Input;
  on_conflict?: InputMaybe<User_Registrations_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_RoleArgs {
  objects: Array<User_Role_Insert_Input>;
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Role_OneArgs {
  object: User_Role_Insert_Input;
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_UsageArgs {
  objects: Array<User_Usage_Insert_Input>;
  on_conflict?: InputMaybe<User_Usage_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_User_Usage_OneArgs {
  object: User_Usage_Insert_Input;
  on_conflict?: InputMaybe<User_Usage_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_UsersArgs {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Users_OneArgs {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Verification_CodesArgs {
  objects: Array<Verification_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Verification_Codes_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Verification_Codes_OneArgs {
  object: Verification_Codes_Insert_Input;
  on_conflict?: InputMaybe<Verification_Codes_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Wine_ProductsArgs {
  objects: Array<Wine_Products_Insert_Input>;
  on_conflict?: InputMaybe<Wine_Products_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootInsert_Wine_Products_OneArgs {
  object: Wine_Products_Insert_Input;
  on_conflict?: InputMaybe<Wine_Products_On_Conflict>;
}


/** mutation root */
export interface Mutation_RootUpdate_ConversationsArgs {
  _set?: InputMaybe<Conversations_Set_Input>;
  where: Conversations_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Conversations_By_PkArgs {
  _set?: InputMaybe<Conversations_Set_Input>;
  pk_columns: Conversations_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Conversations_ManyArgs {
  updates: Array<Conversations_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_MenusArgs {
  _inc?: InputMaybe<Menus_Inc_Input>;
  _set?: InputMaybe<Menus_Set_Input>;
  where: Menus_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Menus_By_PkArgs {
  _inc?: InputMaybe<Menus_Inc_Input>;
  _set?: InputMaybe<Menus_Set_Input>;
  pk_columns: Menus_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Menus_ManyArgs {
  updates: Array<Menus_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_MessagesArgs {
  _append?: InputMaybe<Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
  _prepend?: InputMaybe<Messages_Prepend_Input>;
  _set?: InputMaybe<Messages_Set_Input>;
  where: Messages_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Messages_By_PkArgs {
  _append?: InputMaybe<Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
  _prepend?: InputMaybe<Messages_Prepend_Input>;
  _set?: InputMaybe<Messages_Set_Input>;
  pk_columns: Messages_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Messages_ManyArgs {
  updates: Array<Messages_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairing_Space_Pairing_ItemsArgs {
  _append?: InputMaybe<Pairing_Space_Pairing_Items_Append_Input>;
  _delete_at_path?: InputMaybe<Pairing_Space_Pairing_Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pairing_Space_Pairing_Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pairing_Space_Pairing_Items_Delete_Key_Input>;
  _inc?: InputMaybe<Pairing_Space_Pairing_Items_Inc_Input>;
  _prepend?: InputMaybe<Pairing_Space_Pairing_Items_Prepend_Input>;
  _set?: InputMaybe<Pairing_Space_Pairing_Items_Set_Input>;
  where: Pairing_Space_Pairing_Items_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairing_Space_Pairing_Items_By_PkArgs {
  _append?: InputMaybe<Pairing_Space_Pairing_Items_Append_Input>;
  _delete_at_path?: InputMaybe<Pairing_Space_Pairing_Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pairing_Space_Pairing_Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pairing_Space_Pairing_Items_Delete_Key_Input>;
  _inc?: InputMaybe<Pairing_Space_Pairing_Items_Inc_Input>;
  _prepend?: InputMaybe<Pairing_Space_Pairing_Items_Prepend_Input>;
  _set?: InputMaybe<Pairing_Space_Pairing_Items_Set_Input>;
  pk_columns: Pairing_Space_Pairing_Items_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairing_Space_Pairing_Items_ManyArgs {
  updates: Array<Pairing_Space_Pairing_Items_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairing_Space_PairingsArgs {
  _append?: InputMaybe<Pairing_Space_Pairings_Append_Input>;
  _delete_at_path?: InputMaybe<Pairing_Space_Pairings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pairing_Space_Pairings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pairing_Space_Pairings_Delete_Key_Input>;
  _prepend?: InputMaybe<Pairing_Space_Pairings_Prepend_Input>;
  _set?: InputMaybe<Pairing_Space_Pairings_Set_Input>;
  where: Pairing_Space_Pairings_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairing_Space_Pairings_By_PkArgs {
  _append?: InputMaybe<Pairing_Space_Pairings_Append_Input>;
  _delete_at_path?: InputMaybe<Pairing_Space_Pairings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pairing_Space_Pairings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pairing_Space_Pairings_Delete_Key_Input>;
  _prepend?: InputMaybe<Pairing_Space_Pairings_Prepend_Input>;
  _set?: InputMaybe<Pairing_Space_Pairings_Set_Input>;
  pk_columns: Pairing_Space_Pairings_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairing_Space_Pairings_ManyArgs {
  updates: Array<Pairing_Space_Pairings_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_PairingsArgs {
  _append?: InputMaybe<Pairings_Append_Input>;
  _delete_at_path?: InputMaybe<Pairings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pairings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pairings_Delete_Key_Input>;
  _prepend?: InputMaybe<Pairings_Prepend_Input>;
  _set?: InputMaybe<Pairings_Set_Input>;
  where: Pairings_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairings_By_PkArgs {
  _append?: InputMaybe<Pairings_Append_Input>;
  _delete_at_path?: InputMaybe<Pairings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pairings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pairings_Delete_Key_Input>;
  _prepend?: InputMaybe<Pairings_Prepend_Input>;
  _set?: InputMaybe<Pairings_Set_Input>;
  pk_columns: Pairings_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Pairings_ManyArgs {
  updates: Array<Pairings_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Product_EmbeddingsArgs {
  _set?: InputMaybe<Product_Embeddings_Set_Input>;
  where: Product_Embeddings_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Product_Embeddings_By_PkArgs {
  _set?: InputMaybe<Product_Embeddings_Set_Input>;
  pk_columns: Product_Embeddings_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Product_Embeddings_ManyArgs {
  updates: Array<Product_Embeddings_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Referral_CodesArgs {
  _set?: InputMaybe<Referral_Codes_Set_Input>;
  where: Referral_Codes_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Referral_Codes_By_PkArgs {
  _set?: InputMaybe<Referral_Codes_Set_Input>;
  pk_columns: Referral_Codes_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Referral_Codes_ManyArgs {
  updates: Array<Referral_Codes_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Refresh_TokensArgs {
  _set?: InputMaybe<Refresh_Tokens_Set_Input>;
  where: Refresh_Tokens_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Refresh_Tokens_By_PkArgs {
  _set?: InputMaybe<Refresh_Tokens_Set_Input>;
  pk_columns: Refresh_Tokens_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Refresh_Tokens_ManyArgs {
  updates: Array<Refresh_Tokens_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_SourcesArgs {
  _append?: InputMaybe<Sources_Append_Input>;
  _delete_at_path?: InputMaybe<Sources_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sources_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sources_Delete_Key_Input>;
  _prepend?: InputMaybe<Sources_Prepend_Input>;
  _set?: InputMaybe<Sources_Set_Input>;
  where: Sources_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Sources_By_PkArgs {
  _append?: InputMaybe<Sources_Append_Input>;
  _delete_at_path?: InputMaybe<Sources_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sources_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sources_Delete_Key_Input>;
  _prepend?: InputMaybe<Sources_Prepend_Input>;
  _set?: InputMaybe<Sources_Set_Input>;
  pk_columns: Sources_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Sources_ManyArgs {
  updates: Array<Sources_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Streamline_Image_ProgressArgs {
  _append?: InputMaybe<Streamline_Image_Progress_Append_Input>;
  _delete_at_path?: InputMaybe<Streamline_Image_Progress_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Streamline_Image_Progress_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Streamline_Image_Progress_Delete_Key_Input>;
  _inc?: InputMaybe<Streamline_Image_Progress_Inc_Input>;
  _prepend?: InputMaybe<Streamline_Image_Progress_Prepend_Input>;
  _set?: InputMaybe<Streamline_Image_Progress_Set_Input>;
  where: Streamline_Image_Progress_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Streamline_Image_Progress_By_PkArgs {
  _append?: InputMaybe<Streamline_Image_Progress_Append_Input>;
  _delete_at_path?: InputMaybe<Streamline_Image_Progress_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Streamline_Image_Progress_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Streamline_Image_Progress_Delete_Key_Input>;
  _inc?: InputMaybe<Streamline_Image_Progress_Inc_Input>;
  _prepend?: InputMaybe<Streamline_Image_Progress_Prepend_Input>;
  _set?: InputMaybe<Streamline_Image_Progress_Set_Input>;
  pk_columns: Streamline_Image_Progress_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Streamline_Image_Progress_ManyArgs {
  updates: Array<Streamline_Image_Progress_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Streamline_Processing_ProgressArgs {
  _set?: InputMaybe<Streamline_Processing_Progress_Set_Input>;
  where: Streamline_Processing_Progress_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Streamline_Processing_Progress_By_PkArgs {
  _set?: InputMaybe<Streamline_Processing_Progress_Set_Input>;
  pk_columns: Streamline_Processing_Progress_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Streamline_Processing_Progress_ManyArgs {
  updates: Array<Streamline_Processing_Progress_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_SuppliersArgs {
  _set?: InputMaybe<Suppliers_Set_Input>;
  where: Suppliers_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Suppliers_By_PkArgs {
  _set?: InputMaybe<Suppliers_Set_Input>;
  pk_columns: Suppliers_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Suppliers_ManyArgs {
  updates: Array<Suppliers_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Api_KeysArgs {
  _set?: InputMaybe<User_Api_Keys_Set_Input>;
  where: User_Api_Keys_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Api_Keys_By_PkArgs {
  _set?: InputMaybe<User_Api_Keys_Set_Input>;
  pk_columns: User_Api_Keys_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Api_Keys_ManyArgs {
  updates: Array<User_Api_Keys_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_User_ProfilesArgs {
  _append?: InputMaybe<User_Profiles_Append_Input>;
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Profiles_By_PkArgs {
  _append?: InputMaybe<User_Profiles_Append_Input>;
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Profiles_ManyArgs {
  updates: Array<User_Profiles_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_User_ReferralsArgs {
  _set?: InputMaybe<User_Referrals_Set_Input>;
  where: User_Referrals_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Referrals_By_PkArgs {
  _set?: InputMaybe<User_Referrals_Set_Input>;
  pk_columns: User_Referrals_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Referrals_ManyArgs {
  updates: Array<User_Referrals_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_User_RegistrationsArgs {
  _set?: InputMaybe<User_Registrations_Set_Input>;
  where: User_Registrations_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Registrations_By_PkArgs {
  _set?: InputMaybe<User_Registrations_Set_Input>;
  pk_columns: User_Registrations_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Registrations_ManyArgs {
  updates: Array<User_Registrations_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_User_RoleArgs {
  _set?: InputMaybe<User_Role_Set_Input>;
  where: User_Role_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Role_By_PkArgs {
  _set?: InputMaybe<User_Role_Set_Input>;
  pk_columns: User_Role_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Role_ManyArgs {
  updates: Array<User_Role_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_User_UsageArgs {
  _inc?: InputMaybe<User_Usage_Inc_Input>;
  _set?: InputMaybe<User_Usage_Set_Input>;
  where: User_Usage_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Usage_By_PkArgs {
  _inc?: InputMaybe<User_Usage_Inc_Input>;
  _set?: InputMaybe<User_Usage_Set_Input>;
  pk_columns: User_Usage_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_User_Usage_ManyArgs {
  updates: Array<User_Usage_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_UsersArgs {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Users_By_PkArgs {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Users_ManyArgs {
  updates: Array<Users_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Verification_CodesArgs {
  _set?: InputMaybe<Verification_Codes_Set_Input>;
  where: Verification_Codes_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Verification_Codes_By_PkArgs {
  _set?: InputMaybe<Verification_Codes_Set_Input>;
  pk_columns: Verification_Codes_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Verification_Codes_ManyArgs {
  updates: Array<Verification_Codes_Updates>;
}


/** mutation root */
export interface Mutation_RootUpdate_Wine_ProductsArgs {
  _append?: InputMaybe<Wine_Products_Append_Input>;
  _delete_at_path?: InputMaybe<Wine_Products_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Wine_Products_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Wine_Products_Delete_Key_Input>;
  _prepend?: InputMaybe<Wine_Products_Prepend_Input>;
  _set?: InputMaybe<Wine_Products_Set_Input>;
  where: Wine_Products_Bool_Exp;
}


/** mutation root */
export interface Mutation_RootUpdate_Wine_Products_By_PkArgs {
  _append?: InputMaybe<Wine_Products_Append_Input>;
  _delete_at_path?: InputMaybe<Wine_Products_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Wine_Products_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Wine_Products_Delete_Key_Input>;
  _prepend?: InputMaybe<Wine_Products_Prepend_Input>;
  _set?: InputMaybe<Wine_Products_Set_Input>;
  pk_columns: Wine_Products_Pk_Columns_Input;
}


/** mutation root */
export interface Mutation_RootUpdate_Wine_Products_ManyArgs {
  updates: Array<Wine_Products_Updates>;
}

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface Numeric_Comparison_Exp {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
}

/** column ordering options */
export type Order_By =
  /** in ascending order, nulls last */
  | 'asc'
  /** in ascending order, nulls first */
  | 'asc_nulls_first'
  /** in ascending order, nulls last */
  | 'asc_nulls_last'
  /** in descending order, nulls first */
  | 'desc'
  /** in descending order, nulls first */
  | 'desc_nulls_first'
  /** in descending order, nulls last */
  | 'desc_nulls_last';

/** columns and relationships of "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items {
  __typename?: 'pairing_space_pairing_items';
  board_name: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  dish_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  match_rationale?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  pairing: Pairing_Space_Pairings;
  pairing_id: Scalars['uuid']['output'];
  pairing_rank: Scalars['Int']['output'];
  pairing_score: Scalars['Int']['output'];
  pairing_style: Scalars['String']['output'];
  price?: Maybe<Scalars['numeric']['output']>;
  ranking_short_reason?: Maybe<Scalars['String']['output']>;
  selection?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  supplier_id?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  wine_data: Scalars['jsonb']['output'];
  wine_id: Scalars['String']['output'];
  wine_image_url?: Maybe<Scalars['String']['output']>;
  wine_name?: Maybe<Scalars['String']['output']>;
}


/** columns and relationships of "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_ItemsWine_DataArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}

/** aggregated selection of "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Aggregate {
  __typename?: 'pairing_space_pairing_items_aggregate';
  aggregate?: Maybe<Pairing_Space_Pairing_Items_Aggregate_Fields>;
  nodes: Array<Pairing_Space_Pairing_Items>;
}

export interface Pairing_Space_Pairing_Items_Aggregate_Bool_Exp {
  count?: InputMaybe<Pairing_Space_Pairing_Items_Aggregate_Bool_Exp_Count>;
}

export interface Pairing_Space_Pairing_Items_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Aggregate_Fields {
  __typename?: 'pairing_space_pairing_items_aggregate_fields';
  avg?: Maybe<Pairing_Space_Pairing_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pairing_Space_Pairing_Items_Max_Fields>;
  min?: Maybe<Pairing_Space_Pairing_Items_Min_Fields>;
  stddev?: Maybe<Pairing_Space_Pairing_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Pairing_Space_Pairing_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pairing_Space_Pairing_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Pairing_Space_Pairing_Items_Sum_Fields>;
  var_pop?: Maybe<Pairing_Space_Pairing_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Pairing_Space_Pairing_Items_Var_Samp_Fields>;
  variance?: Maybe<Pairing_Space_Pairing_Items_Variance_Fields>;
}


/** aggregate fields of "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Aggregate_Order_By {
  avg?: InputMaybe<Pairing_Space_Pairing_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pairing_Space_Pairing_Items_Max_Order_By>;
  min?: InputMaybe<Pairing_Space_Pairing_Items_Min_Order_By>;
  stddev?: InputMaybe<Pairing_Space_Pairing_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pairing_Space_Pairing_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pairing_Space_Pairing_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pairing_Space_Pairing_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Pairing_Space_Pairing_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pairing_Space_Pairing_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Pairing_Space_Pairing_Items_Variance_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Pairing_Space_Pairing_Items_Append_Input {
  wine_data?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Arr_Rel_Insert_Input {
  data: Array<Pairing_Space_Pairing_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pairing_Space_Pairing_Items_On_Conflict>;
}

/** aggregate avg on columns */
export interface Pairing_Space_Pairing_Items_Avg_Fields {
  __typename?: 'pairing_space_pairing_items_avg_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by avg() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Avg_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "pairing_space.pairing_items". All fields are combined with a logical 'AND'. */
export interface Pairing_Space_Pairing_Items_Bool_Exp {
  _and?: InputMaybe<Array<Pairing_Space_Pairing_Items_Bool_Exp>>;
  _not?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Pairing_Space_Pairing_Items_Bool_Exp>>;
  board_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dish_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  match_rationale?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pairing?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
  pairing_id?: InputMaybe<Uuid_Comparison_Exp>;
  pairing_rank?: InputMaybe<Int_Comparison_Exp>;
  pairing_score?: InputMaybe<Int_Comparison_Exp>;
  pairing_style?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  ranking_short_reason?: InputMaybe<String_Comparison_Exp>;
  selection?: InputMaybe<String_Comparison_Exp>;
  source_id?: InputMaybe<String_Comparison_Exp>;
  source_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_id?: InputMaybe<String_Comparison_Exp>;
  supplier_name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wine_data?: InputMaybe<Jsonb_Comparison_Exp>;
  wine_id?: InputMaybe<String_Comparison_Exp>;
  wine_image_url?: InputMaybe<String_Comparison_Exp>;
  wine_name?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "pairing_space.pairing_items" */
export type Pairing_Space_Pairing_Items_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'pairing_items_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Pairing_Space_Pairing_Items_Delete_At_Path_Input {
  wine_data?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Pairing_Space_Pairing_Items_Delete_Elem_Input {
  wine_data?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Pairing_Space_Pairing_Items_Delete_Key_Input {
  wine_data?: InputMaybe<Scalars['String']['input']>;
}

/** input type for incrementing numeric columns in table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Inc_Input {
  pairing_rank?: InputMaybe<Scalars['Int']['input']>;
  pairing_score?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
}

/** input type for inserting data into table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Insert_Input {
  board_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dish_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  match_rationale?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pairing?: InputMaybe<Pairing_Space_Pairings_Obj_Rel_Insert_Input>;
  pairing_id?: InputMaybe<Scalars['uuid']['input']>;
  pairing_rank?: InputMaybe<Scalars['Int']['input']>;
  pairing_score?: InputMaybe<Scalars['Int']['input']>;
  pairing_style?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  ranking_short_reason?: InputMaybe<Scalars['String']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['String']['input']>;
  supplier_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_data?: InputMaybe<Scalars['jsonb']['input']>;
  wine_id?: InputMaybe<Scalars['String']['input']>;
  wine_image_url?: InputMaybe<Scalars['String']['input']>;
  wine_name?: InputMaybe<Scalars['String']['input']>;
}

/** aggregate max on columns */
export interface Pairing_Space_Pairing_Items_Max_Fields {
  __typename?: 'pairing_space_pairing_items_max_fields';
  board_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dish_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  match_rationale?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pairing_id?: Maybe<Scalars['uuid']['output']>;
  pairing_rank?: Maybe<Scalars['Int']['output']>;
  pairing_score?: Maybe<Scalars['Int']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  ranking_short_reason?: Maybe<Scalars['String']['output']>;
  selection?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wine_id?: Maybe<Scalars['String']['output']>;
  wine_image_url?: Maybe<Scalars['String']['output']>;
  wine_name?: Maybe<Scalars['String']['output']>;
}

/** order by max() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Max_Order_By {
  board_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dish_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_rationale?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pairing_id?: InputMaybe<Order_By>;
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  pairing_style?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  ranking_short_reason?: InputMaybe<Order_By>;
  selection?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  supplier_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wine_id?: InputMaybe<Order_By>;
  wine_image_url?: InputMaybe<Order_By>;
  wine_name?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Pairing_Space_Pairing_Items_Min_Fields {
  __typename?: 'pairing_space_pairing_items_min_fields';
  board_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dish_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  match_rationale?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pairing_id?: Maybe<Scalars['uuid']['output']>;
  pairing_rank?: Maybe<Scalars['Int']['output']>;
  pairing_score?: Maybe<Scalars['Int']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  ranking_short_reason?: Maybe<Scalars['String']['output']>;
  selection?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wine_id?: Maybe<Scalars['String']['output']>;
  wine_image_url?: Maybe<Scalars['String']['output']>;
  wine_name?: Maybe<Scalars['String']['output']>;
}

/** order by min() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Min_Order_By {
  board_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dish_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_rationale?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pairing_id?: InputMaybe<Order_By>;
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  pairing_style?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  ranking_short_reason?: InputMaybe<Order_By>;
  selection?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  supplier_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wine_id?: InputMaybe<Order_By>;
  wine_image_url?: InputMaybe<Order_By>;
  wine_name?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Mutation_Response {
  __typename?: 'pairing_space_pairing_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pairing_Space_Pairing_Items>;
}

/** on_conflict condition type for table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_On_Conflict {
  constraint: Pairing_Space_Pairing_Items_Constraint;
  update_columns?: Array<Pairing_Space_Pairing_Items_Update_Column>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}

/** Ordering options when selecting data from "pairing_space.pairing_items". */
export interface Pairing_Space_Pairing_Items_Order_By {
  board_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dish_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_rationale?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pairing?: InputMaybe<Pairing_Space_Pairings_Order_By>;
  pairing_id?: InputMaybe<Order_By>;
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  pairing_style?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  ranking_short_reason?: InputMaybe<Order_By>;
  selection?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  supplier_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wine_data?: InputMaybe<Order_By>;
  wine_id?: InputMaybe<Order_By>;
  wine_image_url?: InputMaybe<Order_By>;
  wine_name?: InputMaybe<Order_By>;
}

/** primary key columns input for table: pairing_space.pairing_items */
export interface Pairing_Space_Pairing_Items_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Pairing_Space_Pairing_Items_Prepend_Input {
  wine_data?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "pairing_space.pairing_items" */
export type Pairing_Space_Pairing_Items_Select_Column =
  /** column name */
  | 'board_name'
  /** column name */
  | 'created_at'
  /** column name */
  | 'dish_name'
  /** column name */
  | 'id'
  /** column name */
  | 'match_rationale'
  /** column name */
  | 'notes'
  /** column name */
  | 'pairing_id'
  /** column name */
  | 'pairing_rank'
  /** column name */
  | 'pairing_score'
  /** column name */
  | 'pairing_style'
  /** column name */
  | 'price'
  /** column name */
  | 'ranking_short_reason'
  /** column name */
  | 'selection'
  /** column name */
  | 'source_id'
  /** column name */
  | 'source_name'
  /** column name */
  | 'status'
  /** column name */
  | 'supplier_id'
  /** column name */
  | 'supplier_name'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'wine_data'
  /** column name */
  | 'wine_id'
  /** column name */
  | 'wine_image_url'
  /** column name */
  | 'wine_name';

/** input type for updating data in table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Set_Input {
  board_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dish_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  match_rationale?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pairing_id?: InputMaybe<Scalars['uuid']['input']>;
  pairing_rank?: InputMaybe<Scalars['Int']['input']>;
  pairing_score?: InputMaybe<Scalars['Int']['input']>;
  pairing_style?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  ranking_short_reason?: InputMaybe<Scalars['String']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['String']['input']>;
  supplier_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_data?: InputMaybe<Scalars['jsonb']['input']>;
  wine_id?: InputMaybe<Scalars['String']['input']>;
  wine_image_url?: InputMaybe<Scalars['String']['input']>;
  wine_name?: InputMaybe<Scalars['String']['input']>;
}

/** aggregate stddev on columns */
export interface Pairing_Space_Pairing_Items_Stddev_Fields {
  __typename?: 'pairing_space_pairing_items_stddev_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Stddev_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** aggregate stddev_pop on columns */
export interface Pairing_Space_Pairing_Items_Stddev_Pop_Fields {
  __typename?: 'pairing_space_pairing_items_stddev_pop_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_pop() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Stddev_Pop_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** aggregate stddev_samp on columns */
export interface Pairing_Space_Pairing_Items_Stddev_Samp_Fields {
  __typename?: 'pairing_space_pairing_items_stddev_samp_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_samp() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Stddev_Samp_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "pairing_space_pairing_items" */
export interface Pairing_Space_Pairing_Items_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Pairing_Space_Pairing_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Pairing_Space_Pairing_Items_Stream_Cursor_Value_Input {
  board_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dish_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  match_rationale?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pairing_id?: InputMaybe<Scalars['uuid']['input']>;
  pairing_rank?: InputMaybe<Scalars['Int']['input']>;
  pairing_score?: InputMaybe<Scalars['Int']['input']>;
  pairing_style?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  ranking_short_reason?: InputMaybe<Scalars['String']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['String']['input']>;
  supplier_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_data?: InputMaybe<Scalars['jsonb']['input']>;
  wine_id?: InputMaybe<Scalars['String']['input']>;
  wine_image_url?: InputMaybe<Scalars['String']['input']>;
  wine_name?: InputMaybe<Scalars['String']['input']>;
}

/** aggregate sum on columns */
export interface Pairing_Space_Pairing_Items_Sum_Fields {
  __typename?: 'pairing_space_pairing_items_sum_fields';
  pairing_rank?: Maybe<Scalars['Int']['output']>;
  pairing_score?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
}

/** order by sum() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Sum_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** update columns of table "pairing_space.pairing_items" */
export type Pairing_Space_Pairing_Items_Update_Column =
  /** column name */
  | 'board_name'
  /** column name */
  | 'created_at'
  /** column name */
  | 'dish_name'
  /** column name */
  | 'id'
  /** column name */
  | 'match_rationale'
  /** column name */
  | 'notes'
  /** column name */
  | 'pairing_id'
  /** column name */
  | 'pairing_rank'
  /** column name */
  | 'pairing_score'
  /** column name */
  | 'pairing_style'
  /** column name */
  | 'price'
  /** column name */
  | 'ranking_short_reason'
  /** column name */
  | 'selection'
  /** column name */
  | 'source_id'
  /** column name */
  | 'source_name'
  /** column name */
  | 'status'
  /** column name */
  | 'supplier_id'
  /** column name */
  | 'supplier_name'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'wine_data'
  /** column name */
  | 'wine_id'
  /** column name */
  | 'wine_image_url'
  /** column name */
  | 'wine_name';

export interface Pairing_Space_Pairing_Items_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Pairing_Space_Pairing_Items_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Pairing_Space_Pairing_Items_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Pairing_Space_Pairing_Items_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Pairing_Space_Pairing_Items_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pairing_Space_Pairing_Items_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Pairing_Space_Pairing_Items_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pairing_Space_Pairing_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pairing_Space_Pairing_Items_Bool_Exp;
}

/** aggregate var_pop on columns */
export interface Pairing_Space_Pairing_Items_Var_Pop_Fields {
  __typename?: 'pairing_space_pairing_items_var_pop_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by var_pop() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Var_Pop_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** aggregate var_samp on columns */
export interface Pairing_Space_Pairing_Items_Var_Samp_Fields {
  __typename?: 'pairing_space_pairing_items_var_samp_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by var_samp() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Var_Samp_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** aggregate variance on columns */
export interface Pairing_Space_Pairing_Items_Variance_Fields {
  __typename?: 'pairing_space_pairing_items_variance_fields';
  pairing_rank?: Maybe<Scalars['Float']['output']>;
  pairing_score?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

/** order by variance() on columns of table "pairing_space.pairing_items" */
export interface Pairing_Space_Pairing_Items_Variance_Order_By {
  pairing_rank?: InputMaybe<Order_By>;
  pairing_score?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
}

/** columns and relationships of "pairing_space.pairings" */
export interface Pairing_Space_Pairings {
  __typename?: 'pairing_space_pairings';
  analysis_data?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  pairing_items: Array<Pairing_Space_Pairing_Items>;
  /** An aggregate relationship */
  pairing_items_aggregate: Pairing_Space_Pairing_Items_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
}


/** columns and relationships of "pairing_space.pairings" */
export interface Pairing_Space_PairingsAnalysis_DataArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}


/** columns and relationships of "pairing_space.pairings" */
export interface Pairing_Space_PairingsPairing_ItemsArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairing_Items_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}


/** columns and relationships of "pairing_space.pairings" */
export interface Pairing_Space_PairingsPairing_Items_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairing_Items_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}

/** aggregated selection of "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Aggregate {
  __typename?: 'pairing_space_pairings_aggregate';
  aggregate?: Maybe<Pairing_Space_Pairings_Aggregate_Fields>;
  nodes: Array<Pairing_Space_Pairings>;
}

/** aggregate fields of "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Aggregate_Fields {
  __typename?: 'pairing_space_pairings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pairing_Space_Pairings_Max_Fields>;
  min?: Maybe<Pairing_Space_Pairings_Min_Fields>;
}


/** aggregate fields of "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Pairing_Space_Pairings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Pairing_Space_Pairings_Append_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
}

/** Boolean expression to filter rows from the table "pairing_space.pairings". All fields are combined with a logical 'AND'. */
export interface Pairing_Space_Pairings_Bool_Exp {
  _and?: InputMaybe<Array<Pairing_Space_Pairings_Bool_Exp>>;
  _not?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
  _or?: InputMaybe<Array<Pairing_Space_Pairings_Bool_Exp>>;
  analysis_data?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pairing_items?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
  pairing_items_aggregate?: InputMaybe<Pairing_Space_Pairing_Items_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "pairing_space.pairings" */
export type Pairing_Space_Pairings_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'pairings_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Pairing_Space_Pairings_Delete_At_Path_Input {
  analysis_data?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Pairing_Space_Pairings_Delete_Elem_Input {
  analysis_data?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Pairing_Space_Pairings_Delete_Key_Input {
  analysis_data?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting data into table "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Insert_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pairing_items?: InputMaybe<Pairing_Space_Pairing_Items_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Pairing_Space_Pairings_Max_Fields {
  __typename?: 'pairing_space_pairings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** aggregate min on columns */
export interface Pairing_Space_Pairings_Min_Fields {
  __typename?: 'pairing_space_pairings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** response of any mutation on the table "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Mutation_Response {
  __typename?: 'pairing_space_pairings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pairing_Space_Pairings>;
}

/** input type for inserting object relation for remote table "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Obj_Rel_Insert_Input {
  data: Pairing_Space_Pairings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pairing_Space_Pairings_On_Conflict>;
}

/** on_conflict condition type for table "pairing_space.pairings" */
export interface Pairing_Space_Pairings_On_Conflict {
  constraint: Pairing_Space_Pairings_Constraint;
  update_columns?: Array<Pairing_Space_Pairings_Update_Column>;
  where?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
}

/** Ordering options when selecting data from "pairing_space.pairings". */
export interface Pairing_Space_Pairings_Order_By {
  analysis_data?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pairing_items_aggregate?: InputMaybe<Pairing_Space_Pairing_Items_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: pairing_space.pairings */
export interface Pairing_Space_Pairings_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Pairing_Space_Pairings_Prepend_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "pairing_space.pairings" */
export type Pairing_Space_Pairings_Select_Column =
  /** column name */
  | 'analysis_data'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "pairing_space.pairings" */
export interface Pairing_Space_Pairings_Set_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "pairing_space_pairings" */
export interface Pairing_Space_Pairings_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Pairing_Space_Pairings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Pairing_Space_Pairings_Stream_Cursor_Value_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "pairing_space.pairings" */
export type Pairing_Space_Pairings_Update_Column =
  /** column name */
  | 'analysis_data'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Pairing_Space_Pairings_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Pairing_Space_Pairings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Pairing_Space_Pairings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Pairing_Space_Pairings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Pairing_Space_Pairings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Pairing_Space_Pairings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pairing_Space_Pairings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pairing_Space_Pairings_Bool_Exp;
}

/** Boolean expression to compare columns of type "pairing_status". All fields are combined with logical 'AND'. */
export interface Pairing_Status_Comparison_Exp {
  _eq?: InputMaybe<Scalars['pairing_status']['input']>;
  _gt?: InputMaybe<Scalars['pairing_status']['input']>;
  _gte?: InputMaybe<Scalars['pairing_status']['input']>;
  _in?: InputMaybe<Array<Scalars['pairing_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['pairing_status']['input']>;
  _lte?: InputMaybe<Scalars['pairing_status']['input']>;
  _neq?: InputMaybe<Scalars['pairing_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['pairing_status']['input']>>;
}

/** columns and relationships of "pairings" */
export interface Pairings {
  __typename?: 'pairings';
  analysis_data?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  menus: Array<Menus>;
  /** An aggregate relationship */
  menus_aggregate: Menus_Aggregate;
  params: Scalars['jsonb']['output'];
  status: Scalars['pairing_status']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}


/** columns and relationships of "pairings" */
export interface PairingsAnalysis_DataArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}


/** columns and relationships of "pairings" */
export interface PairingsMenusArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


/** columns and relationships of "pairings" */
export interface PairingsMenus_AggregateArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


/** columns and relationships of "pairings" */
export interface PairingsParamsArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}

/** aggregated selection of "pairings" */
export interface Pairings_Aggregate {
  __typename?: 'pairings_aggregate';
  aggregate?: Maybe<Pairings_Aggregate_Fields>;
  nodes: Array<Pairings>;
}

export interface Pairings_Aggregate_Bool_Exp {
  count?: InputMaybe<Pairings_Aggregate_Bool_Exp_Count>;
}

export interface Pairings_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Pairings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pairings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "pairings" */
export interface Pairings_Aggregate_Fields {
  __typename?: 'pairings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pairings_Max_Fields>;
  min?: Maybe<Pairings_Min_Fields>;
}


/** aggregate fields of "pairings" */
export interface Pairings_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Pairings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "pairings" */
export interface Pairings_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pairings_Max_Order_By>;
  min?: InputMaybe<Pairings_Min_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Pairings_Append_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "pairings" */
export interface Pairings_Arr_Rel_Insert_Input {
  data: Array<Pairings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pairings_On_Conflict>;
}

/** Boolean expression to filter rows from the table "pairings". All fields are combined with a logical 'AND'. */
export interface Pairings_Bool_Exp {
  _and?: InputMaybe<Array<Pairings_Bool_Exp>>;
  _not?: InputMaybe<Pairings_Bool_Exp>;
  _or?: InputMaybe<Array<Pairings_Bool_Exp>>;
  analysis_data?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  menus?: InputMaybe<Menus_Bool_Exp>;
  menus_aggregate?: InputMaybe<Menus_Aggregate_Bool_Exp>;
  params?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<Pairing_Status_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "pairings" */
export type Pairings_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'pairings_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Pairings_Delete_At_Path_Input {
  analysis_data?: InputMaybe<Array<Scalars['String']['input']>>;
  params?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Pairings_Delete_Elem_Input {
  analysis_data?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Pairings_Delete_Key_Input {
  analysis_data?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting data into table "pairings" */
export interface Pairings_Insert_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menus?: InputMaybe<Menus_Arr_Rel_Insert_Input>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['pairing_status']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Pairings_Max_Fields {
  __typename?: 'pairings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['pairing_status']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "pairings" */
export interface Pairings_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Pairings_Min_Fields {
  __typename?: 'pairings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['pairing_status']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "pairings" */
export interface Pairings_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "pairings" */
export interface Pairings_Mutation_Response {
  __typename?: 'pairings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pairings>;
}

/** input type for inserting object relation for remote table "pairings" */
export interface Pairings_Obj_Rel_Insert_Input {
  data: Pairings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pairings_On_Conflict>;
}

/** on_conflict condition type for table "pairings" */
export interface Pairings_On_Conflict {
  constraint: Pairings_Constraint;
  update_columns?: Array<Pairings_Update_Column>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}

/** Ordering options when selecting data from "pairings". */
export interface Pairings_Order_By {
  analysis_data?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  menus_aggregate?: InputMaybe<Menus_Aggregate_Order_By>;
  params?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: pairings */
export interface Pairings_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Pairings_Prepend_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "pairings" */
export type Pairings_Select_Column =
  /** column name */
  | 'analysis_data'
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'id'
  /** column name */
  | 'params'
  /** column name */
  | 'status'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "pairings" */
export interface Pairings_Set_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['pairing_status']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "pairings" */
export interface Pairings_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Pairings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Pairings_Stream_Cursor_Value_Input {
  analysis_data?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['pairing_status']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "pairings" */
export type Pairings_Update_Column =
  /** column name */
  | 'analysis_data'
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'id'
  /** column name */
  | 'params'
  /** column name */
  | 'status'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Pairings_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Pairings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Pairings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Pairings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Pairings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Pairings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pairings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pairings_Bool_Exp;
}

/** columns and relationships of "product_embeddings" */
export interface Product_Embeddings {
  __typename?: 'product_embeddings';
  created_at: Scalars['timestamptz']['output'];
  embedding: Scalars['vector']['output'];
  id: Scalars['uuid']['output'];
  raw_features: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  wine_product: Wine_Products;
  wine_product_id: Scalars['uuid']['output'];
}

/** aggregated selection of "product_embeddings" */
export interface Product_Embeddings_Aggregate {
  __typename?: 'product_embeddings_aggregate';
  aggregate?: Maybe<Product_Embeddings_Aggregate_Fields>;
  nodes: Array<Product_Embeddings>;
}

/** aggregate fields of "product_embeddings" */
export interface Product_Embeddings_Aggregate_Fields {
  __typename?: 'product_embeddings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Embeddings_Max_Fields>;
  min?: Maybe<Product_Embeddings_Min_Fields>;
}


/** aggregate fields of "product_embeddings" */
export interface Product_Embeddings_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Product_Embeddings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Boolean expression to filter rows from the table "product_embeddings". All fields are combined with a logical 'AND'. */
export interface Product_Embeddings_Bool_Exp {
  _and?: InputMaybe<Array<Product_Embeddings_Bool_Exp>>;
  _not?: InputMaybe<Product_Embeddings_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Embeddings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_features?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wine_product?: InputMaybe<Wine_Products_Bool_Exp>;
  wine_product_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "product_embeddings" */
export type Product_Embeddings_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_embeddings_pkey'
  /** unique or primary key constraint on columns "wine_product_id" */
  | 'product_embeddings_product_id_key';

/** input type for inserting data into table "product_embeddings" */
export interface Product_Embeddings_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  raw_features?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_product?: InputMaybe<Wine_Products_Obj_Rel_Insert_Input>;
  wine_product_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Product_Embeddings_Max_Fields {
  __typename?: 'product_embeddings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  raw_features?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wine_product_id?: Maybe<Scalars['uuid']['output']>;
}

/** aggregate min on columns */
export interface Product_Embeddings_Min_Fields {
  __typename?: 'product_embeddings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  raw_features?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wine_product_id?: Maybe<Scalars['uuid']['output']>;
}

/** response of any mutation on the table "product_embeddings" */
export interface Product_Embeddings_Mutation_Response {
  __typename?: 'product_embeddings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Embeddings>;
}

/** input type for inserting object relation for remote table "product_embeddings" */
export interface Product_Embeddings_Obj_Rel_Insert_Input {
  data: Product_Embeddings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Embeddings_On_Conflict>;
}

/** on_conflict condition type for table "product_embeddings" */
export interface Product_Embeddings_On_Conflict {
  constraint: Product_Embeddings_Constraint;
  update_columns?: Array<Product_Embeddings_Update_Column>;
  where?: InputMaybe<Product_Embeddings_Bool_Exp>;
}

/** Ordering options when selecting data from "product_embeddings". */
export interface Product_Embeddings_Order_By {
  created_at?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  raw_features?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wine_product?: InputMaybe<Wine_Products_Order_By>;
  wine_product_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: product_embeddings */
export interface Product_Embeddings_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "product_embeddings" */
export type Product_Embeddings_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'embedding'
  /** column name */
  | 'id'
  /** column name */
  | 'raw_features'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'wine_product_id';

/** input type for updating data in table "product_embeddings" */
export interface Product_Embeddings_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  raw_features?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_product_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "product_embeddings" */
export interface Product_Embeddings_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Product_Embeddings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Product_Embeddings_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  raw_features?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_product_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "product_embeddings" */
export type Product_Embeddings_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'embedding'
  /** column name */
  | 'id'
  /** column name */
  | 'raw_features'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'wine_product_id';

export interface Product_Embeddings_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Embeddings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Embeddings_Bool_Exp;
}

export interface Query_Root {
  __typename?: 'query_root';
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversations_aggregate: Conversations_Aggregate;
  /** fetch data from the table: "conversations" using primary key columns */
  conversations_by_pk?: Maybe<Conversations>;
  /** An array relationship */
  menus: Array<Menus>;
  /** An aggregate relationship */
  menus_aggregate: Menus_Aggregate;
  /** fetch data from the table: "menus" using primary key columns */
  menus_by_pk?: Maybe<Menus>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table: "pairing_space.pairing_items" */
  pairing_space_pairing_items: Array<Pairing_Space_Pairing_Items>;
  /** fetch aggregated fields from the table: "pairing_space.pairing_items" */
  pairing_space_pairing_items_aggregate: Pairing_Space_Pairing_Items_Aggregate;
  /** fetch data from the table: "pairing_space.pairing_items" using primary key columns */
  pairing_space_pairing_items_by_pk?: Maybe<Pairing_Space_Pairing_Items>;
  /** fetch data from the table: "pairing_space.pairings" */
  pairing_space_pairings: Array<Pairing_Space_Pairings>;
  /** fetch aggregated fields from the table: "pairing_space.pairings" */
  pairing_space_pairings_aggregate: Pairing_Space_Pairings_Aggregate;
  /** fetch data from the table: "pairing_space.pairings" using primary key columns */
  pairing_space_pairings_by_pk?: Maybe<Pairing_Space_Pairings>;
  /** An array relationship */
  pairings: Array<Pairings>;
  /** An aggregate relationship */
  pairings_aggregate: Pairings_Aggregate;
  /** fetch data from the table: "pairings" using primary key columns */
  pairings_by_pk?: Maybe<Pairings>;
  /** fetch data from the table: "product_embeddings" */
  product_embeddings: Array<Product_Embeddings>;
  /** fetch aggregated fields from the table: "product_embeddings" */
  product_embeddings_aggregate: Product_Embeddings_Aggregate;
  /** fetch data from the table: "product_embeddings" using primary key columns */
  product_embeddings_by_pk?: Maybe<Product_Embeddings>;
  /** An array relationship */
  referral_codes: Array<Referral_Codes>;
  /** An aggregate relationship */
  referral_codes_aggregate: Referral_Codes_Aggregate;
  /** fetch data from the table: "referral_codes" using primary key columns */
  referral_codes_by_pk?: Maybe<Referral_Codes>;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  /** fetch data from the table: "refresh_tokens" using primary key columns */
  refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** An array relationship */
  sources: Array<Sources>;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  /** fetch data from the table: "sources" using primary key columns */
  sources_by_pk?: Maybe<Sources>;
  /** fetch data from the table: "streamline_image_progress" */
  streamline_image_progress: Array<Streamline_Image_Progress>;
  /** fetch aggregated fields from the table: "streamline_image_progress" */
  streamline_image_progress_aggregate: Streamline_Image_Progress_Aggregate;
  /** fetch data from the table: "streamline_image_progress" using primary key columns */
  streamline_image_progress_by_pk?: Maybe<Streamline_Image_Progress>;
  /** fetch data from the table: "streamline_processing_progress" */
  streamline_processing_progress: Array<Streamline_Processing_Progress>;
  /** fetch aggregated fields from the table: "streamline_processing_progress" */
  streamline_processing_progress_aggregate: Streamline_Processing_Progress_Aggregate;
  /** fetch data from the table: "streamline_processing_progress" using primary key columns */
  streamline_processing_progress_by_pk?: Maybe<Streamline_Processing_Progress>;
  /** fetch data from the table: "suppliers" */
  suppliers: Array<Suppliers>;
  /** fetch aggregated fields from the table: "suppliers" */
  suppliers_aggregate: Suppliers_Aggregate;
  /** fetch data from the table: "suppliers" using primary key columns */
  suppliers_by_pk?: Maybe<Suppliers>;
  /** An array relationship */
  user_api_keys: Array<User_Api_Keys>;
  /** An aggregate relationship */
  user_api_keys_aggregate: User_Api_Keys_Aggregate;
  /** fetch data from the table: "user_api_keys" using primary key columns */
  user_api_keys_by_pk?: Maybe<User_Api_Keys>;
  /** An array relationship */
  user_profiles: Array<User_Profiles>;
  /** An aggregate relationship */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** An array relationship */
  user_referrals: Array<User_Referrals>;
  /** An aggregate relationship */
  user_referrals_aggregate: User_Referrals_Aggregate;
  /** fetch data from the table: "user_referrals" using primary key columns */
  user_referrals_by_pk?: Maybe<User_Referrals>;
  /** An array relationship */
  user_registrations: Array<User_Registrations>;
  /** An aggregate relationship */
  user_registrations_aggregate: User_Registrations_Aggregate;
  /** fetch data from the table: "user_registrations" using primary key columns */
  user_registrations_by_pk?: Maybe<User_Registrations>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table: "user_usage" */
  user_usage: Array<User_Usage>;
  /** fetch aggregated fields from the table: "user_usage" */
  user_usage_aggregate: User_Usage_Aggregate;
  /** fetch data from the table: "user_usage" using primary key columns */
  user_usage_by_pk?: Maybe<User_Usage>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  verification_codes: Array<Verification_Codes>;
  /** An aggregate relationship */
  verification_codes_aggregate: Verification_Codes_Aggregate;
  /** fetch data from the table: "verification_codes" using primary key columns */
  verification_codes_by_pk?: Maybe<Verification_Codes>;
  /** An array relationship */
  wine_products: Array<Wine_Products>;
  /** An aggregate relationship */
  wine_products_aggregate: Wine_Products_Aggregate;
  /** fetch data from the table: "wine_products" using primary key columns */
  wine_products_by_pk?: Maybe<Wine_Products>;
}


export interface Query_RootConversationsArgs {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


export interface Query_RootConversations_AggregateArgs {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


export interface Query_RootConversations_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootMenusArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


export interface Query_RootMenus_AggregateArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


export interface Query_RootMenus_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootMessagesArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


export interface Query_RootMessages_AggregateArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


export interface Query_RootMessages_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootPairing_Space_Pairing_ItemsArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairing_Items_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}


export interface Query_RootPairing_Space_Pairing_Items_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairing_Items_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}


export interface Query_RootPairing_Space_Pairing_Items_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootPairing_Space_PairingsArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairings_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
}


export interface Query_RootPairing_Space_Pairings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairings_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
}


export interface Query_RootPairing_Space_Pairings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootPairingsArgs {
  distinct_on?: InputMaybe<Array<Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairings_Order_By>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


export interface Query_RootPairings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairings_Order_By>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


export interface Query_RootPairings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootProduct_EmbeddingsArgs {
  distinct_on?: InputMaybe<Array<Product_Embeddings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Embeddings_Order_By>>;
  where?: InputMaybe<Product_Embeddings_Bool_Exp>;
}


export interface Query_RootProduct_Embeddings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Product_Embeddings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Embeddings_Order_By>>;
  where?: InputMaybe<Product_Embeddings_Bool_Exp>;
}


export interface Query_RootProduct_Embeddings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootReferral_CodesArgs {
  distinct_on?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referral_Codes_Order_By>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


export interface Query_RootReferral_Codes_AggregateArgs {
  distinct_on?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referral_Codes_Order_By>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


export interface Query_RootReferral_Codes_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootRefresh_TokensArgs {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


export interface Query_RootRefresh_Tokens_AggregateArgs {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


export interface Query_RootRefresh_Tokens_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootSourcesArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


export interface Query_RootSources_AggregateArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


export interface Query_RootSources_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootStreamline_Image_ProgressArgs {
  distinct_on?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Image_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}


export interface Query_RootStreamline_Image_Progress_AggregateArgs {
  distinct_on?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Image_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}


export interface Query_RootStreamline_Image_Progress_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootStreamline_Processing_ProgressArgs {
  distinct_on?: InputMaybe<Array<Streamline_Processing_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Processing_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
}


export interface Query_RootStreamline_Processing_Progress_AggregateArgs {
  distinct_on?: InputMaybe<Array<Streamline_Processing_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Processing_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
}


export interface Query_RootStreamline_Processing_Progress_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootSuppliersArgs {
  distinct_on?: InputMaybe<Array<Suppliers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Suppliers_Order_By>>;
  where?: InputMaybe<Suppliers_Bool_Exp>;
}


export interface Query_RootSuppliers_AggregateArgs {
  distinct_on?: InputMaybe<Array<Suppliers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Suppliers_Order_By>>;
  where?: InputMaybe<Suppliers_Bool_Exp>;
}


export interface Query_RootSuppliers_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootUser_Api_KeysArgs {
  distinct_on?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Api_Keys_Order_By>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


export interface Query_RootUser_Api_Keys_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Api_Keys_Order_By>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


export interface Query_RootUser_Api_Keys_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootUser_ProfilesArgs {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


export interface Query_RootUser_Profiles_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


export interface Query_RootUser_Profiles_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootUser_ReferralsArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


export interface Query_RootUser_Referrals_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


export interface Query_RootUser_Referrals_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootUser_RegistrationsArgs {
  distinct_on?: InputMaybe<Array<User_Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Registrations_Order_By>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}


export interface Query_RootUser_Registrations_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Registrations_Order_By>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}


export interface Query_RootUser_Registrations_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootUser_RoleArgs {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
}


export interface Query_RootUser_Role_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
}


export interface Query_RootUser_Role_By_PkArgs {
  value: Scalars['String']['input'];
}


export interface Query_RootUser_UsageArgs {
  distinct_on?: InputMaybe<Array<User_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Usage_Order_By>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


export interface Query_RootUser_Usage_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Usage_Order_By>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


export interface Query_RootUser_Usage_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootUsersArgs {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
}


export interface Query_RootUsers_AggregateArgs {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
}


export interface Query_RootUsers_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootVerification_CodesArgs {
  distinct_on?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Codes_Order_By>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}


export interface Query_RootVerification_Codes_AggregateArgs {
  distinct_on?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Codes_Order_By>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}


export interface Query_RootVerification_Codes_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Query_RootWine_ProductsArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


export interface Query_RootWine_Products_AggregateArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


export interface Query_RootWine_Products_By_PkArgs {
  id: Scalars['uuid']['input'];
}

/** columns and relationships of "referral_codes" */
export interface Referral_Codes {
  __typename?: 'referral_codes';
  code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_admin_created: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An array relationship */
  user_referrals: Array<User_Referrals>;
  /** An aggregate relationship */
  user_referrals_aggregate: User_Referrals_Aggregate;
  /** An array relationship */
  user_registrations: Array<User_Registrations>;
  /** An aggregate relationship */
  user_registrations_aggregate: User_Registrations_Aggregate;
}


/** columns and relationships of "referral_codes" */
export interface Referral_CodesUser_ReferralsArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


/** columns and relationships of "referral_codes" */
export interface Referral_CodesUser_Referrals_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


/** columns and relationships of "referral_codes" */
export interface Referral_CodesUser_RegistrationsArgs {
  distinct_on?: InputMaybe<Array<User_Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Registrations_Order_By>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}


/** columns and relationships of "referral_codes" */
export interface Referral_CodesUser_Registrations_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Registrations_Order_By>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}

/** aggregated selection of "referral_codes" */
export interface Referral_Codes_Aggregate {
  __typename?: 'referral_codes_aggregate';
  aggregate?: Maybe<Referral_Codes_Aggregate_Fields>;
  nodes: Array<Referral_Codes>;
}

export interface Referral_Codes_Aggregate_Bool_Exp {
  bool_and?: InputMaybe<Referral_Codes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Referral_Codes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Referral_Codes_Aggregate_Bool_Exp_Count>;
}

export interface Referral_Codes_Aggregate_Bool_Exp_Bool_And {
  arguments: Referral_Codes_Select_Column_Referral_Codes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Referral_Codes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
}

export interface Referral_Codes_Aggregate_Bool_Exp_Bool_Or {
  arguments: Referral_Codes_Select_Column_Referral_Codes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Referral_Codes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
}

export interface Referral_Codes_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Referral_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "referral_codes" */
export interface Referral_Codes_Aggregate_Fields {
  __typename?: 'referral_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Referral_Codes_Max_Fields>;
  min?: Maybe<Referral_Codes_Min_Fields>;
}


/** aggregate fields of "referral_codes" */
export interface Referral_Codes_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "referral_codes" */
export interface Referral_Codes_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Referral_Codes_Max_Order_By>;
  min?: InputMaybe<Referral_Codes_Min_Order_By>;
}

/** input type for inserting array relation for remote table "referral_codes" */
export interface Referral_Codes_Arr_Rel_Insert_Input {
  data: Array<Referral_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Referral_Codes_On_Conflict>;
}

/** Boolean expression to filter rows from the table "referral_codes". All fields are combined with a logical 'AND'. */
export interface Referral_Codes_Bool_Exp {
  _and?: InputMaybe<Array<Referral_Codes_Bool_Exp>>;
  _not?: InputMaybe<Referral_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Referral_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_admin_created?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_referrals?: InputMaybe<User_Referrals_Bool_Exp>;
  user_referrals_aggregate?: InputMaybe<User_Referrals_Aggregate_Bool_Exp>;
  user_registrations?: InputMaybe<User_Registrations_Bool_Exp>;
  user_registrations_aggregate?: InputMaybe<User_Registrations_Aggregate_Bool_Exp>;
}

/** unique or primary key constraints on table "referral_codes" */
export type Referral_Codes_Constraint =
  /** unique or primary key constraint on columns "code" */
  | 'referral_codes_code_key'
  /** unique or primary key constraint on columns "id" */
  | 'referral_codes_pkey';

/** input type for inserting data into table "referral_codes" */
export interface Referral_Codes_Insert_Input {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_admin_created?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_referrals?: InputMaybe<User_Referrals_Arr_Rel_Insert_Input>;
  user_registrations?: InputMaybe<User_Registrations_Arr_Rel_Insert_Input>;
}

/** aggregate max on columns */
export interface Referral_Codes_Max_Fields {
  __typename?: 'referral_codes_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by max() on columns of table "referral_codes" */
export interface Referral_Codes_Max_Order_By {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Referral_Codes_Min_Fields {
  __typename?: 'referral_codes_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by min() on columns of table "referral_codes" */
export interface Referral_Codes_Min_Order_By {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "referral_codes" */
export interface Referral_Codes_Mutation_Response {
  __typename?: 'referral_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Referral_Codes>;
}

/** input type for inserting object relation for remote table "referral_codes" */
export interface Referral_Codes_Obj_Rel_Insert_Input {
  data: Referral_Codes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Referral_Codes_On_Conflict>;
}

/** on_conflict condition type for table "referral_codes" */
export interface Referral_Codes_On_Conflict {
  constraint: Referral_Codes_Constraint;
  update_columns?: Array<Referral_Codes_Update_Column>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}

/** Ordering options when selecting data from "referral_codes". */
export interface Referral_Codes_Order_By {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_admin_created?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_referrals_aggregate?: InputMaybe<User_Referrals_Aggregate_Order_By>;
  user_registrations_aggregate?: InputMaybe<User_Registrations_Aggregate_Order_By>;
}

/** primary key columns input for table: referral_codes */
export interface Referral_Codes_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "referral_codes" */
export type Referral_Codes_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'is_admin_created'
  /** column name */
  | 'updated_at';

/** select "referral_codes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "referral_codes" */
export type Referral_Codes_Select_Column_Referral_Codes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_admin_created';

/** select "referral_codes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "referral_codes" */
export type Referral_Codes_Select_Column_Referral_Codes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_admin_created';

/** input type for updating data in table "referral_codes" */
export interface Referral_Codes_Set_Input {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_admin_created?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** Streaming cursor of the table "referral_codes" */
export interface Referral_Codes_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Referral_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Referral_Codes_Stream_Cursor_Value_Input {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_admin_created?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** update columns of table "referral_codes" */
export type Referral_Codes_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'is_admin_created'
  /** column name */
  | 'updated_at';

export interface Referral_Codes_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Referral_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Referral_Codes_Bool_Exp;
}

/** columns and relationships of "refresh_tokens" */
export interface Refresh_Tokens {
  __typename?: 'refresh_tokens';
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  revoked?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}

/** aggregated selection of "refresh_tokens" */
export interface Refresh_Tokens_Aggregate {
  __typename?: 'refresh_tokens_aggregate';
  aggregate?: Maybe<Refresh_Tokens_Aggregate_Fields>;
  nodes: Array<Refresh_Tokens>;
}

export interface Refresh_Tokens_Aggregate_Bool_Exp {
  bool_and?: InputMaybe<Refresh_Tokens_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Refresh_Tokens_Aggregate_Bool_Exp_Count>;
}

export interface Refresh_Tokens_Aggregate_Bool_Exp_Bool_And {
  arguments: Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
}

export interface Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or {
  arguments: Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
}

export interface Refresh_Tokens_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "refresh_tokens" */
export interface Refresh_Tokens_Aggregate_Fields {
  __typename?: 'refresh_tokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Refresh_Tokens_Max_Fields>;
  min?: Maybe<Refresh_Tokens_Min_Fields>;
}


/** aggregate fields of "refresh_tokens" */
export interface Refresh_Tokens_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "refresh_tokens" */
export interface Refresh_Tokens_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refresh_Tokens_Max_Order_By>;
  min?: InputMaybe<Refresh_Tokens_Min_Order_By>;
}

/** input type for inserting array relation for remote table "refresh_tokens" */
export interface Refresh_Tokens_Arr_Rel_Insert_Input {
  data: Array<Refresh_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refresh_Tokens_On_Conflict>;
}

/** Boolean expression to filter rows from the table "refresh_tokens". All fields are combined with a logical 'AND'. */
export interface Refresh_Tokens_Bool_Exp {
  _and?: InputMaybe<Array<Refresh_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Refresh_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  revoked?: InputMaybe<Boolean_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "refresh_tokens" */
export type Refresh_Tokens_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'refresh_tokens_pkey'
  /** unique or primary key constraint on columns "token" */
  | 'refresh_tokens_token_key';

/** input type for inserting data into table "refresh_tokens" */
export interface Refresh_Tokens_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Refresh_Tokens_Max_Fields {
  __typename?: 'refresh_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "refresh_tokens" */
export interface Refresh_Tokens_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Refresh_Tokens_Min_Fields {
  __typename?: 'refresh_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "refresh_tokens" */
export interface Refresh_Tokens_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "refresh_tokens" */
export interface Refresh_Tokens_Mutation_Response {
  __typename?: 'refresh_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Tokens>;
}

/** on_conflict condition type for table "refresh_tokens" */
export interface Refresh_Tokens_On_Conflict {
  constraint: Refresh_Tokens_Constraint;
  update_columns?: Array<Refresh_Tokens_Update_Column>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}

/** Ordering options when selecting data from "refresh_tokens". */
export interface Refresh_Tokens_Order_By {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revoked?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: refresh_tokens */
export interface Refresh_Tokens_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "refresh_tokens" */
export type Refresh_Tokens_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'revoked'
  /** column name */
  | 'token'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** select "refresh_tokens_aggregate_bool_exp_bool_and_arguments_columns" columns of table "refresh_tokens" */
export type Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'revoked';

/** select "refresh_tokens_aggregate_bool_exp_bool_or_arguments_columns" columns of table "refresh_tokens" */
export type Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'revoked';

/** input type for updating data in table "refresh_tokens" */
export interface Refresh_Tokens_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "refresh_tokens" */
export interface Refresh_Tokens_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Refresh_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Refresh_Tokens_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "refresh_tokens" */
export type Refresh_Tokens_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'revoked'
  /** column name */
  | 'token'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Refresh_Tokens_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refresh_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refresh_Tokens_Bool_Exp;
}

/** columns and relationships of "sources" */
export interface Sources {
  __typename?: 'sources';
  created_at: Scalars['timestamptz']['output'];
  error?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  parse_status: Scalars['String']['output'];
  /** An array relationship */
  products: Array<Wine_Products>;
  /** An aggregate relationship */
  products_aggregate: Wine_Products_Aggregate;
  /** An object relationship */
  streamline_processing_progress?: Maybe<Streamline_Processing_Progress>;
  /** An object relationship */
  supplier?: Maybe<Suppliers>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  wine_products: Array<Wine_Products>;
  /** An aggregate relationship */
  wine_products_aggregate: Wine_Products_Aggregate;
}


/** columns and relationships of "sources" */
export interface SourcesMetadataArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}


/** columns and relationships of "sources" */
export interface SourcesProductsArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


/** columns and relationships of "sources" */
export interface SourcesProducts_AggregateArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


/** columns and relationships of "sources" */
export interface SourcesWine_ProductsArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


/** columns and relationships of "sources" */
export interface SourcesWine_Products_AggregateArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}

/** aggregated selection of "sources" */
export interface Sources_Aggregate {
  __typename?: 'sources_aggregate';
  aggregate?: Maybe<Sources_Aggregate_Fields>;
  nodes: Array<Sources>;
}

export interface Sources_Aggregate_Bool_Exp {
  count?: InputMaybe<Sources_Aggregate_Bool_Exp_Count>;
}

export interface Sources_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sources_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "sources" */
export interface Sources_Aggregate_Fields {
  __typename?: 'sources_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sources_Max_Fields>;
  min?: Maybe<Sources_Min_Fields>;
}


/** aggregate fields of "sources" */
export interface Sources_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "sources" */
export interface Sources_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sources_Max_Order_By>;
  min?: InputMaybe<Sources_Min_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Sources_Append_Input {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "sources" */
export interface Sources_Arr_Rel_Insert_Input {
  data: Array<Sources_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sources_On_Conflict>;
}

/** Boolean expression to filter rows from the table "sources". All fields are combined with a logical 'AND'. */
export interface Sources_Bool_Exp {
  _and?: InputMaybe<Array<Sources_Bool_Exp>>;
  _not?: InputMaybe<Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Sources_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parse_status?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Wine_Products_Bool_Exp>;
  products_aggregate?: InputMaybe<Wine_Products_Aggregate_Bool_Exp>;
  streamline_processing_progress?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
  supplier?: InputMaybe<Suppliers_Bool_Exp>;
  supplier_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  wine_products?: InputMaybe<Wine_Products_Bool_Exp>;
  wine_products_aggregate?: InputMaybe<Wine_Products_Aggregate_Bool_Exp>;
}

/** unique or primary key constraints on table "sources" */
export type Sources_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'sources_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Sources_Delete_At_Path_Input {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Sources_Delete_Elem_Input {
  metadata?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Sources_Delete_Key_Input {
  metadata?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting data into table "sources" */
export interface Sources_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parse_status?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Wine_Products_Arr_Rel_Insert_Input>;
  streamline_processing_progress?: InputMaybe<Streamline_Processing_Progress_Obj_Rel_Insert_Input>;
  supplier?: InputMaybe<Suppliers_Obj_Rel_Insert_Input>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  wine_products?: InputMaybe<Wine_Products_Arr_Rel_Insert_Input>;
}

/** aggregate max on columns */
export interface Sources_Max_Fields {
  __typename?: 'sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parse_status?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "sources" */
export interface Sources_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parse_status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Sources_Min_Fields {
  __typename?: 'sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parse_status?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "sources" */
export interface Sources_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parse_status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "sources" */
export interface Sources_Mutation_Response {
  __typename?: 'sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sources>;
}

/** input type for inserting object relation for remote table "sources" */
export interface Sources_Obj_Rel_Insert_Input {
  data: Sources_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sources_On_Conflict>;
}

/** on_conflict condition type for table "sources" */
export interface Sources_On_Conflict {
  constraint: Sources_Constraint;
  update_columns?: Array<Sources_Update_Column>;
  where?: InputMaybe<Sources_Bool_Exp>;
}

/** Ordering options when selecting data from "sources". */
export interface Sources_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parse_status?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Wine_Products_Aggregate_Order_By>;
  streamline_processing_progress?: InputMaybe<Streamline_Processing_Progress_Order_By>;
  supplier?: InputMaybe<Suppliers_Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  wine_products_aggregate?: InputMaybe<Wine_Products_Aggregate_Order_By>;
}

/** primary key columns input for table: sources */
export interface Sources_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Sources_Prepend_Input {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "sources" */
export type Sources_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'hash'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'parse_status'
  /** column name */
  | 'supplier_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'url'
  /** column name */
  | 'user_id';

/** input type for updating data in table "sources" */
export interface Sources_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parse_status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "sources" */
export interface Sources_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Sources_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parse_status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "sources" */
export type Sources_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'hash'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'parse_status'
  /** column name */
  | 'supplier_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'url'
  /** column name */
  | 'user_id';

export interface Sources_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sources_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sources_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sources_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sources_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sources_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sources_Bool_Exp;
}

/** columns and relationships of "streamline_image_progress" */
export interface Streamline_Image_Progress {
  __typename?: 'streamline_image_progress';
  created_at: Scalars['timestamptz']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image_index: Scalars['Int']['output'];
  progress_id: Scalars['uuid']['output'];
  result?: Maybe<Scalars['jsonb']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  streamline_processing_progress: Streamline_Processing_Progress;
  updated_at: Scalars['timestamptz']['output'];
}


/** columns and relationships of "streamline_image_progress" */
export interface Streamline_Image_ProgressResultArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}

/** aggregated selection of "streamline_image_progress" */
export interface Streamline_Image_Progress_Aggregate {
  __typename?: 'streamline_image_progress_aggregate';
  aggregate?: Maybe<Streamline_Image_Progress_Aggregate_Fields>;
  nodes: Array<Streamline_Image_Progress>;
}

export interface Streamline_Image_Progress_Aggregate_Bool_Exp {
  count?: InputMaybe<Streamline_Image_Progress_Aggregate_Bool_Exp_Count>;
}

export interface Streamline_Image_Progress_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "streamline_image_progress" */
export interface Streamline_Image_Progress_Aggregate_Fields {
  __typename?: 'streamline_image_progress_aggregate_fields';
  avg?: Maybe<Streamline_Image_Progress_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Streamline_Image_Progress_Max_Fields>;
  min?: Maybe<Streamline_Image_Progress_Min_Fields>;
  stddev?: Maybe<Streamline_Image_Progress_Stddev_Fields>;
  stddev_pop?: Maybe<Streamline_Image_Progress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Streamline_Image_Progress_Stddev_Samp_Fields>;
  sum?: Maybe<Streamline_Image_Progress_Sum_Fields>;
  var_pop?: Maybe<Streamline_Image_Progress_Var_Pop_Fields>;
  var_samp?: Maybe<Streamline_Image_Progress_Var_Samp_Fields>;
  variance?: Maybe<Streamline_Image_Progress_Variance_Fields>;
}


/** aggregate fields of "streamline_image_progress" */
export interface Streamline_Image_Progress_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Aggregate_Order_By {
  avg?: InputMaybe<Streamline_Image_Progress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Streamline_Image_Progress_Max_Order_By>;
  min?: InputMaybe<Streamline_Image_Progress_Min_Order_By>;
  stddev?: InputMaybe<Streamline_Image_Progress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Streamline_Image_Progress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Streamline_Image_Progress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Streamline_Image_Progress_Sum_Order_By>;
  var_pop?: InputMaybe<Streamline_Image_Progress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Streamline_Image_Progress_Var_Samp_Order_By>;
  variance?: InputMaybe<Streamline_Image_Progress_Variance_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Streamline_Image_Progress_Append_Input {
  result?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "streamline_image_progress" */
export interface Streamline_Image_Progress_Arr_Rel_Insert_Input {
  data: Array<Streamline_Image_Progress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Streamline_Image_Progress_On_Conflict>;
}

/** aggregate avg on columns */
export interface Streamline_Image_Progress_Avg_Fields {
  __typename?: 'streamline_image_progress_avg_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by avg() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Avg_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "streamline_image_progress". All fields are combined with a logical 'AND'. */
export interface Streamline_Image_Progress_Bool_Exp {
  _and?: InputMaybe<Array<Streamline_Image_Progress_Bool_Exp>>;
  _not?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<Streamline_Image_Progress_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  progress_id?: InputMaybe<Uuid_Comparison_Exp>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  streamline_processing_progress?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
}

/** unique or primary key constraints on table "streamline_image_progress" */
export type Streamline_Image_Progress_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'streamline_image_progress_pkey'
  /** unique or primary key constraint on columns "progress_id", "image_index" */
  | 'streamline_image_progress_progress_id_image_index_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Streamline_Image_Progress_Delete_At_Path_Input {
  result?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Streamline_Image_Progress_Delete_Elem_Input {
  result?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Streamline_Image_Progress_Delete_Key_Input {
  result?: InputMaybe<Scalars['String']['input']>;
}

/** input type for incrementing numeric columns in table "streamline_image_progress" */
export interface Streamline_Image_Progress_Inc_Input {
  image_index?: InputMaybe<Scalars['Int']['input']>;
}

/** input type for inserting data into table "streamline_image_progress" */
export interface Streamline_Image_Progress_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_index?: InputMaybe<Scalars['Int']['input']>;
  progress_id?: InputMaybe<Scalars['uuid']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  streamline_processing_progress?: InputMaybe<Streamline_Processing_Progress_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** aggregate max on columns */
export interface Streamline_Image_Progress_Max_Fields {
  __typename?: 'streamline_image_progress_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  progress_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by max() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  progress_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Streamline_Image_Progress_Min_Fields {
  __typename?: 'streamline_image_progress_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  progress_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by min() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  progress_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "streamline_image_progress" */
export interface Streamline_Image_Progress_Mutation_Response {
  __typename?: 'streamline_image_progress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Streamline_Image_Progress>;
}

/** on_conflict condition type for table "streamline_image_progress" */
export interface Streamline_Image_Progress_On_Conflict {
  constraint: Streamline_Image_Progress_Constraint;
  update_columns?: Array<Streamline_Image_Progress_Update_Column>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}

/** Ordering options when selecting data from "streamline_image_progress". */
export interface Streamline_Image_Progress_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  progress_id?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  streamline_processing_progress?: InputMaybe<Streamline_Processing_Progress_Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** primary key columns input for table: streamline_image_progress */
export interface Streamline_Image_Progress_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Streamline_Image_Progress_Prepend_Input {
  result?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "streamline_image_progress" */
export type Streamline_Image_Progress_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'id'
  /** column name */
  | 'image_index'
  /** column name */
  | 'progress_id'
  /** column name */
  | 'result'
  /** column name */
  | 'status'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "streamline_image_progress" */
export interface Streamline_Image_Progress_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_index?: InputMaybe<Scalars['Int']['input']>;
  progress_id?: InputMaybe<Scalars['uuid']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** aggregate stddev on columns */
export interface Streamline_Image_Progress_Stddev_Fields {
  __typename?: 'streamline_image_progress_stddev_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Stddev_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** aggregate stddev_pop on columns */
export interface Streamline_Image_Progress_Stddev_Pop_Fields {
  __typename?: 'streamline_image_progress_stddev_pop_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_pop() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Stddev_Pop_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** aggregate stddev_samp on columns */
export interface Streamline_Image_Progress_Stddev_Samp_Fields {
  __typename?: 'streamline_image_progress_stddev_samp_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_samp() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Stddev_Samp_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "streamline_image_progress" */
export interface Streamline_Image_Progress_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Streamline_Image_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Streamline_Image_Progress_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_index?: InputMaybe<Scalars['Int']['input']>;
  progress_id?: InputMaybe<Scalars['uuid']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** aggregate sum on columns */
export interface Streamline_Image_Progress_Sum_Fields {
  __typename?: 'streamline_image_progress_sum_fields';
  image_index?: Maybe<Scalars['Int']['output']>;
}

/** order by sum() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Sum_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** update columns of table "streamline_image_progress" */
export type Streamline_Image_Progress_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'id'
  /** column name */
  | 'image_index'
  /** column name */
  | 'progress_id'
  /** column name */
  | 'result'
  /** column name */
  | 'status'
  /** column name */
  | 'updated_at';

export interface Streamline_Image_Progress_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Streamline_Image_Progress_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Streamline_Image_Progress_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Streamline_Image_Progress_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Streamline_Image_Progress_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Streamline_Image_Progress_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Streamline_Image_Progress_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Streamline_Image_Progress_Set_Input>;
  /** filter the rows which have to be updated */
  where: Streamline_Image_Progress_Bool_Exp;
}

/** aggregate var_pop on columns */
export interface Streamline_Image_Progress_Var_Pop_Fields {
  __typename?: 'streamline_image_progress_var_pop_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by var_pop() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Var_Pop_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** aggregate var_samp on columns */
export interface Streamline_Image_Progress_Var_Samp_Fields {
  __typename?: 'streamline_image_progress_var_samp_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by var_samp() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Var_Samp_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** aggregate variance on columns */
export interface Streamline_Image_Progress_Variance_Fields {
  __typename?: 'streamline_image_progress_variance_fields';
  image_index?: Maybe<Scalars['Float']['output']>;
}

/** order by variance() on columns of table "streamline_image_progress" */
export interface Streamline_Image_Progress_Variance_Order_By {
  image_index?: InputMaybe<Order_By>;
}

/** columns and relationships of "streamline_processing_progress" */
export interface Streamline_Processing_Progress {
  __typename?: 'streamline_processing_progress';
  created_at: Scalars['timestamptz']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  source?: Maybe<Sources>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An array relationship */
  streamline_image_progresses: Array<Streamline_Image_Progress>;
  /** An aggregate relationship */
  streamline_image_progresses_aggregate: Streamline_Image_Progress_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
}


/** columns and relationships of "streamline_processing_progress" */
export interface Streamline_Processing_ProgressStreamline_Image_ProgressesArgs {
  distinct_on?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Image_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}


/** columns and relationships of "streamline_processing_progress" */
export interface Streamline_Processing_ProgressStreamline_Image_Progresses_AggregateArgs {
  distinct_on?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Image_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}

/** aggregated selection of "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Aggregate {
  __typename?: 'streamline_processing_progress_aggregate';
  aggregate?: Maybe<Streamline_Processing_Progress_Aggregate_Fields>;
  nodes: Array<Streamline_Processing_Progress>;
}

/** aggregate fields of "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Aggregate_Fields {
  __typename?: 'streamline_processing_progress_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Streamline_Processing_Progress_Max_Fields>;
  min?: Maybe<Streamline_Processing_Progress_Min_Fields>;
}


/** aggregate fields of "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Streamline_Processing_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Boolean expression to filter rows from the table "streamline_processing_progress". All fields are combined with a logical 'AND'. */
export interface Streamline_Processing_Progress_Bool_Exp {
  _and?: InputMaybe<Array<Streamline_Processing_Progress_Bool_Exp>>;
  _not?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<Streamline_Processing_Progress_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<Sources_Bool_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  streamline_image_progresses?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
  streamline_image_progresses_aggregate?: InputMaybe<Streamline_Image_Progress_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
}

/** unique or primary key constraints on table "streamline_processing_progress" */
export type Streamline_Processing_Progress_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'streamline_processing_progress_pkey'
  /** unique or primary key constraint on columns "source_id" */
  | 'streamline_processing_progress_source_id_key';

/** input type for inserting data into table "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Sources_Obj_Rel_Insert_Input>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  streamline_image_progresses?: InputMaybe<Streamline_Image_Progress_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** aggregate max on columns */
export interface Streamline_Processing_Progress_Max_Fields {
  __typename?: 'streamline_processing_progress_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** aggregate min on columns */
export interface Streamline_Processing_Progress_Min_Fields {
  __typename?: 'streamline_processing_progress_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** response of any mutation on the table "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Mutation_Response {
  __typename?: 'streamline_processing_progress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Streamline_Processing_Progress>;
}

/** input type for inserting object relation for remote table "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Obj_Rel_Insert_Input {
  data: Streamline_Processing_Progress_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Streamline_Processing_Progress_On_Conflict>;
}

/** on_conflict condition type for table "streamline_processing_progress" */
export interface Streamline_Processing_Progress_On_Conflict {
  constraint: Streamline_Processing_Progress_Constraint;
  update_columns?: Array<Streamline_Processing_Progress_Update_Column>;
  where?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
}

/** Ordering options when selecting data from "streamline_processing_progress". */
export interface Streamline_Processing_Progress_Order_By {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Sources_Order_By>;
  source_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  streamline_image_progresses_aggregate?: InputMaybe<Streamline_Image_Progress_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** primary key columns input for table: streamline_processing_progress */
export interface Streamline_Processing_Progress_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "streamline_processing_progress" */
export type Streamline_Processing_Progress_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'id'
  /** column name */
  | 'source_id'
  /** column name */
  | 'status'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** Streaming cursor of the table "streamline_processing_progress" */
export interface Streamline_Processing_Progress_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Streamline_Processing_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Streamline_Processing_Progress_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** update columns of table "streamline_processing_progress" */
export type Streamline_Processing_Progress_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'error'
  /** column name */
  | 'id'
  /** column name */
  | 'source_id'
  /** column name */
  | 'status'
  /** column name */
  | 'updated_at';

export interface Streamline_Processing_Progress_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Streamline_Processing_Progress_Set_Input>;
  /** filter the rows which have to be updated */
  where: Streamline_Processing_Progress_Bool_Exp;
}

export interface Subscription_Root {
  __typename?: 'subscription_root';
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversations_aggregate: Conversations_Aggregate;
  /** fetch data from the table: "conversations" using primary key columns */
  conversations_by_pk?: Maybe<Conversations>;
  /** fetch data from the table in a streaming manner: "conversations" */
  conversations_stream: Array<Conversations>;
  /** An array relationship */
  menus: Array<Menus>;
  /** An aggregate relationship */
  menus_aggregate: Menus_Aggregate;
  /** fetch data from the table: "menus" using primary key columns */
  menus_by_pk?: Maybe<Menus>;
  /** fetch data from the table in a streaming manner: "menus" */
  menus_stream: Array<Menus>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table in a streaming manner: "messages" */
  messages_stream: Array<Messages>;
  /** fetch data from the table: "pairing_space.pairing_items" */
  pairing_space_pairing_items: Array<Pairing_Space_Pairing_Items>;
  /** fetch aggregated fields from the table: "pairing_space.pairing_items" */
  pairing_space_pairing_items_aggregate: Pairing_Space_Pairing_Items_Aggregate;
  /** fetch data from the table: "pairing_space.pairing_items" using primary key columns */
  pairing_space_pairing_items_by_pk?: Maybe<Pairing_Space_Pairing_Items>;
  /** fetch data from the table in a streaming manner: "pairing_space.pairing_items" */
  pairing_space_pairing_items_stream: Array<Pairing_Space_Pairing_Items>;
  /** fetch data from the table: "pairing_space.pairings" */
  pairing_space_pairings: Array<Pairing_Space_Pairings>;
  /** fetch aggregated fields from the table: "pairing_space.pairings" */
  pairing_space_pairings_aggregate: Pairing_Space_Pairings_Aggregate;
  /** fetch data from the table: "pairing_space.pairings" using primary key columns */
  pairing_space_pairings_by_pk?: Maybe<Pairing_Space_Pairings>;
  /** fetch data from the table in a streaming manner: "pairing_space.pairings" */
  pairing_space_pairings_stream: Array<Pairing_Space_Pairings>;
  /** An array relationship */
  pairings: Array<Pairings>;
  /** An aggregate relationship */
  pairings_aggregate: Pairings_Aggregate;
  /** fetch data from the table: "pairings" using primary key columns */
  pairings_by_pk?: Maybe<Pairings>;
  /** fetch data from the table in a streaming manner: "pairings" */
  pairings_stream: Array<Pairings>;
  /** fetch data from the table: "product_embeddings" */
  product_embeddings: Array<Product_Embeddings>;
  /** fetch aggregated fields from the table: "product_embeddings" */
  product_embeddings_aggregate: Product_Embeddings_Aggregate;
  /** fetch data from the table: "product_embeddings" using primary key columns */
  product_embeddings_by_pk?: Maybe<Product_Embeddings>;
  /** fetch data from the table in a streaming manner: "product_embeddings" */
  product_embeddings_stream: Array<Product_Embeddings>;
  /** An array relationship */
  referral_codes: Array<Referral_Codes>;
  /** An aggregate relationship */
  referral_codes_aggregate: Referral_Codes_Aggregate;
  /** fetch data from the table: "referral_codes" using primary key columns */
  referral_codes_by_pk?: Maybe<Referral_Codes>;
  /** fetch data from the table in a streaming manner: "referral_codes" */
  referral_codes_stream: Array<Referral_Codes>;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  /** fetch data from the table: "refresh_tokens" using primary key columns */
  refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** fetch data from the table in a streaming manner: "refresh_tokens" */
  refresh_tokens_stream: Array<Refresh_Tokens>;
  /** An array relationship */
  sources: Array<Sources>;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  /** fetch data from the table: "sources" using primary key columns */
  sources_by_pk?: Maybe<Sources>;
  /** fetch data from the table in a streaming manner: "sources" */
  sources_stream: Array<Sources>;
  /** fetch data from the table: "streamline_image_progress" */
  streamline_image_progress: Array<Streamline_Image_Progress>;
  /** fetch aggregated fields from the table: "streamline_image_progress" */
  streamline_image_progress_aggregate: Streamline_Image_Progress_Aggregate;
  /** fetch data from the table: "streamline_image_progress" using primary key columns */
  streamline_image_progress_by_pk?: Maybe<Streamline_Image_Progress>;
  /** fetch data from the table in a streaming manner: "streamline_image_progress" */
  streamline_image_progress_stream: Array<Streamline_Image_Progress>;
  /** fetch data from the table: "streamline_processing_progress" */
  streamline_processing_progress: Array<Streamline_Processing_Progress>;
  /** fetch aggregated fields from the table: "streamline_processing_progress" */
  streamline_processing_progress_aggregate: Streamline_Processing_Progress_Aggregate;
  /** fetch data from the table: "streamline_processing_progress" using primary key columns */
  streamline_processing_progress_by_pk?: Maybe<Streamline_Processing_Progress>;
  /** fetch data from the table in a streaming manner: "streamline_processing_progress" */
  streamline_processing_progress_stream: Array<Streamline_Processing_Progress>;
  /** fetch data from the table: "suppliers" */
  suppliers: Array<Suppliers>;
  /** fetch aggregated fields from the table: "suppliers" */
  suppliers_aggregate: Suppliers_Aggregate;
  /** fetch data from the table: "suppliers" using primary key columns */
  suppliers_by_pk?: Maybe<Suppliers>;
  /** fetch data from the table in a streaming manner: "suppliers" */
  suppliers_stream: Array<Suppliers>;
  /** An array relationship */
  user_api_keys: Array<User_Api_Keys>;
  /** An aggregate relationship */
  user_api_keys_aggregate: User_Api_Keys_Aggregate;
  /** fetch data from the table: "user_api_keys" using primary key columns */
  user_api_keys_by_pk?: Maybe<User_Api_Keys>;
  /** fetch data from the table in a streaming manner: "user_api_keys" */
  user_api_keys_stream: Array<User_Api_Keys>;
  /** An array relationship */
  user_profiles: Array<User_Profiles>;
  /** An aggregate relationship */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>;
  /** An array relationship */
  user_referrals: Array<User_Referrals>;
  /** An aggregate relationship */
  user_referrals_aggregate: User_Referrals_Aggregate;
  /** fetch data from the table: "user_referrals" using primary key columns */
  user_referrals_by_pk?: Maybe<User_Referrals>;
  /** fetch data from the table in a streaming manner: "user_referrals" */
  user_referrals_stream: Array<User_Referrals>;
  /** An array relationship */
  user_registrations: Array<User_Registrations>;
  /** An aggregate relationship */
  user_registrations_aggregate: User_Registrations_Aggregate;
  /** fetch data from the table: "user_registrations" using primary key columns */
  user_registrations_by_pk?: Maybe<User_Registrations>;
  /** fetch data from the table in a streaming manner: "user_registrations" */
  user_registrations_stream: Array<User_Registrations>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table in a streaming manner: "user_role" */
  user_role_stream: Array<User_Role>;
  /** fetch data from the table: "user_usage" */
  user_usage: Array<User_Usage>;
  /** fetch aggregated fields from the table: "user_usage" */
  user_usage_aggregate: User_Usage_Aggregate;
  /** fetch data from the table: "user_usage" using primary key columns */
  user_usage_by_pk?: Maybe<User_Usage>;
  /** fetch data from the table in a streaming manner: "user_usage" */
  user_usage_stream: Array<User_Usage>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  verification_codes: Array<Verification_Codes>;
  /** An aggregate relationship */
  verification_codes_aggregate: Verification_Codes_Aggregate;
  /** fetch data from the table: "verification_codes" using primary key columns */
  verification_codes_by_pk?: Maybe<Verification_Codes>;
  /** fetch data from the table in a streaming manner: "verification_codes" */
  verification_codes_stream: Array<Verification_Codes>;
  /** An array relationship */
  wine_products: Array<Wine_Products>;
  /** An aggregate relationship */
  wine_products_aggregate: Wine_Products_Aggregate;
  /** fetch data from the table: "wine_products" using primary key columns */
  wine_products_by_pk?: Maybe<Wine_Products>;
  /** fetch data from the table in a streaming manner: "wine_products" */
  wine_products_stream: Array<Wine_Products>;
}


export interface Subscription_RootConversationsArgs {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


export interface Subscription_RootConversations_AggregateArgs {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


export interface Subscription_RootConversations_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootConversations_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Conversations_Stream_Cursor_Input>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


export interface Subscription_RootMenusArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


export interface Subscription_RootMenus_AggregateArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


export interface Subscription_RootMenus_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootMenus_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Menus_Stream_Cursor_Input>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


export interface Subscription_RootMessagesArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


export interface Subscription_RootMessages_AggregateArgs {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


export interface Subscription_RootMessages_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootMessages_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Messages_Bool_Exp>;
}


export interface Subscription_RootPairing_Space_Pairing_ItemsArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairing_Items_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}


export interface Subscription_RootPairing_Space_Pairing_Items_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairing_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairing_Items_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}


export interface Subscription_RootPairing_Space_Pairing_Items_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootPairing_Space_Pairing_Items_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pairing_Space_Pairing_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Pairing_Space_Pairing_Items_Bool_Exp>;
}


export interface Subscription_RootPairing_Space_PairingsArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairings_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
}


export interface Subscription_RootPairing_Space_Pairings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairing_Space_Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairing_Space_Pairings_Order_By>>;
  where?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
}


export interface Subscription_RootPairing_Space_Pairings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootPairing_Space_Pairings_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pairing_Space_Pairings_Stream_Cursor_Input>>;
  where?: InputMaybe<Pairing_Space_Pairings_Bool_Exp>;
}


export interface Subscription_RootPairingsArgs {
  distinct_on?: InputMaybe<Array<Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairings_Order_By>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


export interface Subscription_RootPairings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairings_Order_By>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


export interface Subscription_RootPairings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootPairings_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pairings_Stream_Cursor_Input>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


export interface Subscription_RootProduct_EmbeddingsArgs {
  distinct_on?: InputMaybe<Array<Product_Embeddings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Embeddings_Order_By>>;
  where?: InputMaybe<Product_Embeddings_Bool_Exp>;
}


export interface Subscription_RootProduct_Embeddings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Product_Embeddings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Embeddings_Order_By>>;
  where?: InputMaybe<Product_Embeddings_Bool_Exp>;
}


export interface Subscription_RootProduct_Embeddings_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootProduct_Embeddings_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Embeddings_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Embeddings_Bool_Exp>;
}


export interface Subscription_RootReferral_CodesArgs {
  distinct_on?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referral_Codes_Order_By>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


export interface Subscription_RootReferral_Codes_AggregateArgs {
  distinct_on?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referral_Codes_Order_By>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


export interface Subscription_RootReferral_Codes_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootReferral_Codes_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Referral_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


export interface Subscription_RootRefresh_TokensArgs {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


export interface Subscription_RootRefresh_Tokens_AggregateArgs {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


export interface Subscription_RootRefresh_Tokens_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootRefresh_Tokens_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refresh_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


export interface Subscription_RootSourcesArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


export interface Subscription_RootSources_AggregateArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


export interface Subscription_RootSources_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootSources_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sources_Stream_Cursor_Input>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


export interface Subscription_RootStreamline_Image_ProgressArgs {
  distinct_on?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Image_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}


export interface Subscription_RootStreamline_Image_Progress_AggregateArgs {
  distinct_on?: InputMaybe<Array<Streamline_Image_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Image_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}


export interface Subscription_RootStreamline_Image_Progress_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootStreamline_Image_Progress_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Streamline_Image_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<Streamline_Image_Progress_Bool_Exp>;
}


export interface Subscription_RootStreamline_Processing_ProgressArgs {
  distinct_on?: InputMaybe<Array<Streamline_Processing_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Processing_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
}


export interface Subscription_RootStreamline_Processing_Progress_AggregateArgs {
  distinct_on?: InputMaybe<Array<Streamline_Processing_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Streamline_Processing_Progress_Order_By>>;
  where?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
}


export interface Subscription_RootStreamline_Processing_Progress_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootStreamline_Processing_Progress_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Streamline_Processing_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<Streamline_Processing_Progress_Bool_Exp>;
}


export interface Subscription_RootSuppliersArgs {
  distinct_on?: InputMaybe<Array<Suppliers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Suppliers_Order_By>>;
  where?: InputMaybe<Suppliers_Bool_Exp>;
}


export interface Subscription_RootSuppliers_AggregateArgs {
  distinct_on?: InputMaybe<Array<Suppliers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Suppliers_Order_By>>;
  where?: InputMaybe<Suppliers_Bool_Exp>;
}


export interface Subscription_RootSuppliers_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootSuppliers_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Suppliers_Stream_Cursor_Input>>;
  where?: InputMaybe<Suppliers_Bool_Exp>;
}


export interface Subscription_RootUser_Api_KeysArgs {
  distinct_on?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Api_Keys_Order_By>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


export interface Subscription_RootUser_Api_Keys_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Api_Keys_Order_By>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


export interface Subscription_RootUser_Api_Keys_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootUser_Api_Keys_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Api_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


export interface Subscription_RootUser_ProfilesArgs {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


export interface Subscription_RootUser_Profiles_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


export interface Subscription_RootUser_Profiles_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootUser_Profiles_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


export interface Subscription_RootUser_ReferralsArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


export interface Subscription_RootUser_Referrals_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


export interface Subscription_RootUser_Referrals_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootUser_Referrals_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Referrals_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


export interface Subscription_RootUser_RegistrationsArgs {
  distinct_on?: InputMaybe<Array<User_Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Registrations_Order_By>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}


export interface Subscription_RootUser_Registrations_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Registrations_Order_By>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}


export interface Subscription_RootUser_Registrations_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootUser_Registrations_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Registrations_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}


export interface Subscription_RootUser_RoleArgs {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
}


export interface Subscription_RootUser_Role_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
}


export interface Subscription_RootUser_Role_By_PkArgs {
  value: Scalars['String']['input'];
}


export interface Subscription_RootUser_Role_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
}


export interface Subscription_RootUser_UsageArgs {
  distinct_on?: InputMaybe<Array<User_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Usage_Order_By>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


export interface Subscription_RootUser_Usage_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Usage_Order_By>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


export interface Subscription_RootUser_Usage_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootUser_Usage_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Usage_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


export interface Subscription_RootUsersArgs {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
}


export interface Subscription_RootUsers_AggregateArgs {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
}


export interface Subscription_RootUsers_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootUsers_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
}


export interface Subscription_RootVerification_CodesArgs {
  distinct_on?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Codes_Order_By>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}


export interface Subscription_RootVerification_Codes_AggregateArgs {
  distinct_on?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Codes_Order_By>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}


export interface Subscription_RootVerification_Codes_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootVerification_Codes_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Verification_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}


export interface Subscription_RootWine_ProductsArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


export interface Subscription_RootWine_Products_AggregateArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


export interface Subscription_RootWine_Products_By_PkArgs {
  id: Scalars['uuid']['input'];
}


export interface Subscription_RootWine_Products_StreamArgs {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wine_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}

/** columns and relationships of "suppliers" */
export interface Suppliers {
  __typename?: 'suppliers';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  sources: Array<Sources>;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  wine_products: Array<Wine_Products>;
  /** An aggregate relationship */
  wine_products_aggregate: Wine_Products_Aggregate;
}


/** columns and relationships of "suppliers" */
export interface SuppliersSourcesArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


/** columns and relationships of "suppliers" */
export interface SuppliersSources_AggregateArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


/** columns and relationships of "suppliers" */
export interface SuppliersWine_ProductsArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}


/** columns and relationships of "suppliers" */
export interface SuppliersWine_Products_AggregateArgs {
  distinct_on?: InputMaybe<Array<Wine_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wine_Products_Order_By>>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}

/** aggregated selection of "suppliers" */
export interface Suppliers_Aggregate {
  __typename?: 'suppliers_aggregate';
  aggregate?: Maybe<Suppliers_Aggregate_Fields>;
  nodes: Array<Suppliers>;
}

/** aggregate fields of "suppliers" */
export interface Suppliers_Aggregate_Fields {
  __typename?: 'suppliers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Suppliers_Max_Fields>;
  min?: Maybe<Suppliers_Min_Fields>;
}


/** aggregate fields of "suppliers" */
export interface Suppliers_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Suppliers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Boolean expression to filter rows from the table "suppliers". All fields are combined with a logical 'AND'. */
export interface Suppliers_Bool_Exp {
  _and?: InputMaybe<Array<Suppliers_Bool_Exp>>;
  _not?: InputMaybe<Suppliers_Bool_Exp>;
  _or?: InputMaybe<Array<Suppliers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sources?: InputMaybe<Sources_Bool_Exp>;
  sources_aggregate?: InputMaybe<Sources_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wine_products?: InputMaybe<Wine_Products_Bool_Exp>;
  wine_products_aggregate?: InputMaybe<Wine_Products_Aggregate_Bool_Exp>;
}

/** unique or primary key constraints on table "suppliers" */
export type Suppliers_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'suppliers_pkey';

/** input type for inserting data into table "suppliers" */
export interface Suppliers_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Sources_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wine_products?: InputMaybe<Wine_Products_Arr_Rel_Insert_Input>;
}

/** aggregate max on columns */
export interface Suppliers_Max_Fields {
  __typename?: 'suppliers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** aggregate min on columns */
export interface Suppliers_Min_Fields {
  __typename?: 'suppliers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** response of any mutation on the table "suppliers" */
export interface Suppliers_Mutation_Response {
  __typename?: 'suppliers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Suppliers>;
}

/** input type for inserting object relation for remote table "suppliers" */
export interface Suppliers_Obj_Rel_Insert_Input {
  data: Suppliers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Suppliers_On_Conflict>;
}

/** on_conflict condition type for table "suppliers" */
export interface Suppliers_On_Conflict {
  constraint: Suppliers_Constraint;
  update_columns?: Array<Suppliers_Update_Column>;
  where?: InputMaybe<Suppliers_Bool_Exp>;
}

/** Ordering options when selecting data from "suppliers". */
export interface Suppliers_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sources_aggregate?: InputMaybe<Sources_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wine_products_aggregate?: InputMaybe<Wine_Products_Aggregate_Order_By>;
}

/** primary key columns input for table: suppliers */
export interface Suppliers_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "suppliers" */
export type Suppliers_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "suppliers" */
export interface Suppliers_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** Streaming cursor of the table "suppliers" */
export interface Suppliers_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Suppliers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Suppliers_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** update columns of table "suppliers" */
export type Suppliers_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at';

export interface Suppliers_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Suppliers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Suppliers_Bool_Exp;
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface Timestamptz_Comparison_Exp {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
}

/** columns and relationships of "user_api_keys" */
export interface User_Api_Keys {
  __typename?: 'user_api_keys';
  api_key: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}

/** aggregated selection of "user_api_keys" */
export interface User_Api_Keys_Aggregate {
  __typename?: 'user_api_keys_aggregate';
  aggregate?: Maybe<User_Api_Keys_Aggregate_Fields>;
  nodes: Array<User_Api_Keys>;
}

export interface User_Api_Keys_Aggregate_Bool_Exp {
  count?: InputMaybe<User_Api_Keys_Aggregate_Bool_Exp_Count>;
}

export interface User_Api_Keys_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Api_Keys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "user_api_keys" */
export interface User_Api_Keys_Aggregate_Fields {
  __typename?: 'user_api_keys_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Api_Keys_Max_Fields>;
  min?: Maybe<User_Api_Keys_Min_Fields>;
}


/** aggregate fields of "user_api_keys" */
export interface User_Api_Keys_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "user_api_keys" */
export interface User_Api_Keys_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Api_Keys_Max_Order_By>;
  min?: InputMaybe<User_Api_Keys_Min_Order_By>;
}

/** input type for inserting array relation for remote table "user_api_keys" */
export interface User_Api_Keys_Arr_Rel_Insert_Input {
  data: Array<User_Api_Keys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Api_Keys_On_Conflict>;
}

/** Boolean expression to filter rows from the table "user_api_keys". All fields are combined with a logical 'AND'. */
export interface User_Api_Keys_Bool_Exp {
  _and?: InputMaybe<Array<User_Api_Keys_Bool_Exp>>;
  _not?: InputMaybe<User_Api_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<User_Api_Keys_Bool_Exp>>;
  api_key?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "user_api_keys" */
export type User_Api_Keys_Constraint =
  /** unique or primary key constraint on columns "api_key" */
  | 'user_api_keys_api_key_idx'
  /** unique or primary key constraint on columns "id" */
  | 'user_api_keys_pkey';

/** input type for inserting data into table "user_api_keys" */
export interface User_Api_Keys_Insert_Input {
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface User_Api_Keys_Max_Fields {
  __typename?: 'user_api_keys_max_fields';
  api_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "user_api_keys" */
export interface User_Api_Keys_Max_Order_By {
  api_key?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface User_Api_Keys_Min_Fields {
  __typename?: 'user_api_keys_min_fields';
  api_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "user_api_keys" */
export interface User_Api_Keys_Min_Order_By {
  api_key?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "user_api_keys" */
export interface User_Api_Keys_Mutation_Response {
  __typename?: 'user_api_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Api_Keys>;
}

/** on_conflict condition type for table "user_api_keys" */
export interface User_Api_Keys_On_Conflict {
  constraint: User_Api_Keys_Constraint;
  update_columns?: Array<User_Api_Keys_Update_Column>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}

/** Ordering options when selecting data from "user_api_keys". */
export interface User_Api_Keys_Order_By {
  api_key?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: user_api_keys */
export interface User_Api_Keys_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "user_api_keys" */
export type User_Api_Keys_Select_Column =
  /** column name */
  | 'api_key'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "user_api_keys" */
export interface User_Api_Keys_Set_Input {
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "user_api_keys" */
export interface User_Api_Keys_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: User_Api_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface User_Api_Keys_Stream_Cursor_Value_Input {
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "user_api_keys" */
export type User_Api_Keys_Update_Column =
  /** column name */
  | 'api_key'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface User_Api_Keys_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Api_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Api_Keys_Bool_Exp;
}

/** columns and relationships of "user_profiles" */
export interface User_Profiles {
  __typename?: 'user_profiles';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  links?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  system_prompt?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}


/** columns and relationships of "user_profiles" */
export interface User_ProfilesLinksArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}

/** aggregated selection of "user_profiles" */
export interface User_Profiles_Aggregate {
  __typename?: 'user_profiles_aggregate';
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>;
  nodes: Array<User_Profiles>;
}

export interface User_Profiles_Aggregate_Bool_Exp {
  count?: InputMaybe<User_Profiles_Aggregate_Bool_Exp_Count>;
}

export interface User_Profiles_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Profiles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "user_profiles" */
export interface User_Profiles_Aggregate_Fields {
  __typename?: 'user_profiles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Profiles_Max_Fields>;
  min?: Maybe<User_Profiles_Min_Fields>;
}


/** aggregate fields of "user_profiles" */
export interface User_Profiles_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "user_profiles" */
export interface User_Profiles_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Profiles_Max_Order_By>;
  min?: InputMaybe<User_Profiles_Min_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface User_Profiles_Append_Input {
  links?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "user_profiles" */
export interface User_Profiles_Arr_Rel_Insert_Input {
  data: Array<User_Profiles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
}

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export interface User_Profiles_Bool_Exp {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  _not?: InputMaybe<User_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  links?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  system_prompt?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "user_profiles" */
export type User_Profiles_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_profiles_pkey'
  /** unique or primary key constraint on columns "user_id" */
  | 'user_profiles_user_id_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface User_Profiles_Delete_At_Path_Input {
  links?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface User_Profiles_Delete_Elem_Input {
  links?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface User_Profiles_Delete_Key_Input {
  links?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting data into table "user_profiles" */
export interface User_Profiles_Insert_Input {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  links?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface User_Profiles_Max_Fields {
  __typename?: 'user_profiles_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  system_prompt?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "user_profiles" */
export interface User_Profiles_Max_Order_By {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  system_prompt?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface User_Profiles_Min_Fields {
  __typename?: 'user_profiles_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  system_prompt?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "user_profiles" */
export interface User_Profiles_Min_Order_By {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  system_prompt?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "user_profiles" */
export interface User_Profiles_Mutation_Response {
  __typename?: 'user_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>;
}

/** input type for inserting object relation for remote table "user_profiles" */
export interface User_Profiles_Obj_Rel_Insert_Input {
  data: User_Profiles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
}

/** on_conflict condition type for table "user_profiles" */
export interface User_Profiles_On_Conflict {
  constraint: User_Profiles_Constraint;
  update_columns?: Array<User_Profiles_Update_Column>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}

/** Ordering options when selecting data from "user_profiles". */
export interface User_Profiles_Order_By {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  links?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  system_prompt?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: user_profiles */
export interface User_Profiles_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface User_Profiles_Prepend_Input {
  links?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "user_profiles" */
export type User_Profiles_Select_Column =
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'links'
  /** column name */
  | 'name'
  /** column name */
  | 'system_prompt'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "user_profiles" */
export interface User_Profiles_Set_Input {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  links?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "user_profiles" */
export interface User_Profiles_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface User_Profiles_Stream_Cursor_Value_Input {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  links?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "user_profiles" */
export type User_Profiles_Update_Column =
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'links'
  /** column name */
  | 'name'
  /** column name */
  | 'system_prompt'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface User_Profiles_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Profiles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp;
}

/** columns and relationships of "user_referrals" */
export interface User_Referrals {
  __typename?: 'user_referrals';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  referral_code: Referral_Codes;
  referral_code_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}

/** aggregated selection of "user_referrals" */
export interface User_Referrals_Aggregate {
  __typename?: 'user_referrals_aggregate';
  aggregate?: Maybe<User_Referrals_Aggregate_Fields>;
  nodes: Array<User_Referrals>;
}

export interface User_Referrals_Aggregate_Bool_Exp {
  count?: InputMaybe<User_Referrals_Aggregate_Bool_Exp_Count>;
}

export interface User_Referrals_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<User_Referrals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Referrals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "user_referrals" */
export interface User_Referrals_Aggregate_Fields {
  __typename?: 'user_referrals_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Referrals_Max_Fields>;
  min?: Maybe<User_Referrals_Min_Fields>;
}


/** aggregate fields of "user_referrals" */
export interface User_Referrals_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<User_Referrals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "user_referrals" */
export interface User_Referrals_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Referrals_Max_Order_By>;
  min?: InputMaybe<User_Referrals_Min_Order_By>;
}

/** input type for inserting array relation for remote table "user_referrals" */
export interface User_Referrals_Arr_Rel_Insert_Input {
  data: Array<User_Referrals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Referrals_On_Conflict>;
}

/** Boolean expression to filter rows from the table "user_referrals". All fields are combined with a logical 'AND'. */
export interface User_Referrals_Bool_Exp {
  _and?: InputMaybe<Array<User_Referrals_Bool_Exp>>;
  _not?: InputMaybe<User_Referrals_Bool_Exp>;
  _or?: InputMaybe<Array<User_Referrals_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  referral_code?: InputMaybe<Referral_Codes_Bool_Exp>;
  referral_code_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "user_referrals" */
export type User_Referrals_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_referrals_pkey'
  /** unique or primary key constraint on columns "user_id", "referral_code_id" */
  | 'user_referrals_user_id_referral_code_id_key';

/** input type for inserting data into table "user_referrals" */
export interface User_Referrals_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referral_code?: InputMaybe<Referral_Codes_Obj_Rel_Insert_Input>;
  referral_code_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface User_Referrals_Max_Fields {
  __typename?: 'user_referrals_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referral_code_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "user_referrals" */
export interface User_Referrals_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referral_code_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface User_Referrals_Min_Fields {
  __typename?: 'user_referrals_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referral_code_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "user_referrals" */
export interface User_Referrals_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referral_code_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "user_referrals" */
export interface User_Referrals_Mutation_Response {
  __typename?: 'user_referrals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Referrals>;
}

/** on_conflict condition type for table "user_referrals" */
export interface User_Referrals_On_Conflict {
  constraint: User_Referrals_Constraint;
  update_columns?: Array<User_Referrals_Update_Column>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}

/** Ordering options when selecting data from "user_referrals". */
export interface User_Referrals_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referral_code?: InputMaybe<Referral_Codes_Order_By>;
  referral_code_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: user_referrals */
export interface User_Referrals_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "user_referrals" */
export type User_Referrals_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'referral_code_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "user_referrals" */
export interface User_Referrals_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referral_code_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "user_referrals" */
export interface User_Referrals_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: User_Referrals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface User_Referrals_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referral_code_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "user_referrals" */
export type User_Referrals_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'referral_code_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface User_Referrals_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Referrals_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Referrals_Bool_Exp;
}

/** columns and relationships of "user_registrations" */
export interface User_Registrations {
  __typename?: 'user_registrations';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  referral_code: Referral_Codes;
  referral_code_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  verification_code: Scalars['String']['output'];
}

/** aggregated selection of "user_registrations" */
export interface User_Registrations_Aggregate {
  __typename?: 'user_registrations_aggregate';
  aggregate?: Maybe<User_Registrations_Aggregate_Fields>;
  nodes: Array<User_Registrations>;
}

export interface User_Registrations_Aggregate_Bool_Exp {
  count?: InputMaybe<User_Registrations_Aggregate_Bool_Exp_Count>;
}

export interface User_Registrations_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<User_Registrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Registrations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "user_registrations" */
export interface User_Registrations_Aggregate_Fields {
  __typename?: 'user_registrations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Registrations_Max_Fields>;
  min?: Maybe<User_Registrations_Min_Fields>;
}


/** aggregate fields of "user_registrations" */
export interface User_Registrations_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<User_Registrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "user_registrations" */
export interface User_Registrations_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Registrations_Max_Order_By>;
  min?: InputMaybe<User_Registrations_Min_Order_By>;
}

/** input type for inserting array relation for remote table "user_registrations" */
export interface User_Registrations_Arr_Rel_Insert_Input {
  data: Array<User_Registrations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Registrations_On_Conflict>;
}

/** Boolean expression to filter rows from the table "user_registrations". All fields are combined with a logical 'AND'. */
export interface User_Registrations_Bool_Exp {
  _and?: InputMaybe<Array<User_Registrations_Bool_Exp>>;
  _not?: InputMaybe<User_Registrations_Bool_Exp>;
  _or?: InputMaybe<Array<User_Registrations_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  referral_code?: InputMaybe<Referral_Codes_Bool_Exp>;
  referral_code_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_code?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "user_registrations" */
export type User_Registrations_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_registrations_pkey';

/** input type for inserting data into table "user_registrations" */
export interface User_Registrations_Insert_Input {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Referral_Codes_Obj_Rel_Insert_Input>;
  referral_code_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
}

/** aggregate max on columns */
export interface User_Registrations_Max_Fields {
  __typename?: 'user_registrations_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referral_code_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verification_code?: Maybe<Scalars['String']['output']>;
}

/** order by max() on columns of table "user_registrations" */
export interface User_Registrations_Max_Order_By {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referral_code_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface User_Registrations_Min_Fields {
  __typename?: 'user_registrations_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referral_code_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verification_code?: Maybe<Scalars['String']['output']>;
}

/** order by min() on columns of table "user_registrations" */
export interface User_Registrations_Min_Order_By {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referral_code_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "user_registrations" */
export interface User_Registrations_Mutation_Response {
  __typename?: 'user_registrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Registrations>;
}

/** on_conflict condition type for table "user_registrations" */
export interface User_Registrations_On_Conflict {
  constraint: User_Registrations_Constraint;
  update_columns?: Array<User_Registrations_Update_Column>;
  where?: InputMaybe<User_Registrations_Bool_Exp>;
}

/** Ordering options when selecting data from "user_registrations". */
export interface User_Registrations_Order_By {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referral_code?: InputMaybe<Referral_Codes_Order_By>;
  referral_code_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
}

/** primary key columns input for table: user_registrations */
export interface User_Registrations_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "user_registrations" */
export type User_Registrations_Select_Column =
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'created_at'
  /** column name */
  | 'email'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'referral_code_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'verification_code';

/** input type for updating data in table "user_registrations" */
export interface User_Registrations_Set_Input {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referral_code_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "user_registrations" */
export interface User_Registrations_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: User_Registrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface User_Registrations_Stream_Cursor_Value_Input {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referral_code_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
}

/** update columns of table "user_registrations" */
export type User_Registrations_Update_Column =
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'created_at'
  /** column name */
  | 'email'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'referral_code_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'verification_code';

export interface User_Registrations_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Registrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Registrations_Bool_Exp;
}

/** columns and relationships of "user_role" */
export interface User_Role {
  __typename?: 'user_role';
  comment: Scalars['String']['output'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  value: Scalars['String']['output'];
}


/** columns and relationships of "user_role" */
export interface User_RoleUsersArgs {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
}


/** columns and relationships of "user_role" */
export interface User_RoleUsers_AggregateArgs {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
}

/** aggregated selection of "user_role" */
export interface User_Role_Aggregate {
  __typename?: 'user_role_aggregate';
  aggregate?: Maybe<User_Role_Aggregate_Fields>;
  nodes: Array<User_Role>;
}

/** aggregate fields of "user_role" */
export interface User_Role_Aggregate_Fields {
  __typename?: 'user_role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Role_Max_Fields>;
  min?: Maybe<User_Role_Min_Fields>;
}


/** aggregate fields of "user_role" */
export interface User_Role_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<User_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Boolean expression to filter rows from the table "user_role". All fields are combined with a logical 'AND'. */
export interface User_Role_Bool_Exp {
  _and?: InputMaybe<Array<User_Role_Bool_Exp>>;
  _not?: InputMaybe<User_Role_Bool_Exp>;
  _or?: InputMaybe<Array<User_Role_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "user_role" */
export type User_Role_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_role_pkey';

export type User_Role_Enum =
  /** admin */
  | 'admin'
  /** user */
  | 'user';

/** Boolean expression to compare columns of type "user_role_enum". All fields are combined with logical 'AND'. */
export interface User_Role_Enum_Comparison_Exp {
  _eq?: InputMaybe<User_Role_Enum>;
  _in?: InputMaybe<Array<User_Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Role_Enum>;
  _nin?: InputMaybe<Array<User_Role_Enum>>;
}

/** input type for inserting data into table "user_role" */
export interface User_Role_Insert_Input {
  comment?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
}

/** aggregate max on columns */
export interface User_Role_Max_Fields {
  __typename?: 'user_role_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

/** aggregate min on columns */
export interface User_Role_Min_Fields {
  __typename?: 'user_role_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

/** response of any mutation on the table "user_role" */
export interface User_Role_Mutation_Response {
  __typename?: 'user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Role>;
}

/** input type for inserting object relation for remote table "user_role" */
export interface User_Role_Obj_Rel_Insert_Input {
  data: User_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
}

/** on_conflict condition type for table "user_role" */
export interface User_Role_On_Conflict {
  constraint: User_Role_Constraint;
  update_columns?: Array<User_Role_Update_Column>;
  where?: InputMaybe<User_Role_Bool_Exp>;
}

/** Ordering options when selecting data from "user_role". */
export interface User_Role_Order_By {
  comment?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
}

/** primary key columns input for table: user_role */
export interface User_Role_Pk_Columns_Input {
  value: Scalars['String']['input'];
}

/** select columns of table "user_role" */
export type User_Role_Select_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'value';

/** input type for updating data in table "user_role" */
export interface User_Role_Set_Input {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "user_role" */
export interface User_Role_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: User_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface User_Role_Stream_Cursor_Value_Input {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

/** update columns of table "user_role" */
export type User_Role_Update_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'value';

export interface User_Role_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Role_Bool_Exp;
}

/** columns and relationships of "user_usage" */
export interface User_Usage {
  __typename?: 'user_usage';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  reset_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  usage_count: Scalars['Int']['output'];
  usage_limit?: Maybe<Scalars['Int']['output']>;
  usage_type: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}

/** aggregated selection of "user_usage" */
export interface User_Usage_Aggregate {
  __typename?: 'user_usage_aggregate';
  aggregate?: Maybe<User_Usage_Aggregate_Fields>;
  nodes: Array<User_Usage>;
}

export interface User_Usage_Aggregate_Bool_Exp {
  count?: InputMaybe<User_Usage_Aggregate_Bool_Exp_Count>;
}

export interface User_Usage_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<User_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Usage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "user_usage" */
export interface User_Usage_Aggregate_Fields {
  __typename?: 'user_usage_aggregate_fields';
  avg?: Maybe<User_Usage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Usage_Max_Fields>;
  min?: Maybe<User_Usage_Min_Fields>;
  stddev?: Maybe<User_Usage_Stddev_Fields>;
  stddev_pop?: Maybe<User_Usage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Usage_Stddev_Samp_Fields>;
  sum?: Maybe<User_Usage_Sum_Fields>;
  var_pop?: Maybe<User_Usage_Var_Pop_Fields>;
  var_samp?: Maybe<User_Usage_Var_Samp_Fields>;
  variance?: Maybe<User_Usage_Variance_Fields>;
}


/** aggregate fields of "user_usage" */
export interface User_Usage_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<User_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "user_usage" */
export interface User_Usage_Aggregate_Order_By {
  avg?: InputMaybe<User_Usage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Usage_Max_Order_By>;
  min?: InputMaybe<User_Usage_Min_Order_By>;
  stddev?: InputMaybe<User_Usage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Usage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Usage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Usage_Sum_Order_By>;
  var_pop?: InputMaybe<User_Usage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Usage_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Usage_Variance_Order_By>;
}

/** input type for inserting array relation for remote table "user_usage" */
export interface User_Usage_Arr_Rel_Insert_Input {
  data: Array<User_Usage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Usage_On_Conflict>;
}

/** aggregate avg on columns */
export interface User_Usage_Avg_Fields {
  __typename?: 'user_usage_avg_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by avg() on columns of table "user_usage" */
export interface User_Usage_Avg_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "user_usage". All fields are combined with a logical 'AND'. */
export interface User_Usage_Bool_Exp {
  _and?: InputMaybe<Array<User_Usage_Bool_Exp>>;
  _not?: InputMaybe<User_Usage_Bool_Exp>;
  _or?: InputMaybe<Array<User_Usage_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reset_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usage_count?: InputMaybe<Int_Comparison_Exp>;
  usage_limit?: InputMaybe<Int_Comparison_Exp>;
  usage_type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "user_usage" */
export type User_Usage_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_usage_pkey'
  /** unique or primary key constraint on columns "user_id", "usage_type" */
  | 'user_usage_user_idx';

/** input type for incrementing numeric columns in table "user_usage" */
export interface User_Usage_Inc_Input {
  usage_count?: InputMaybe<Scalars['Int']['input']>;
  usage_limit?: InputMaybe<Scalars['Int']['input']>;
}

/** input type for inserting data into table "user_usage" */
export interface User_Usage_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reset_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usage_count?: InputMaybe<Scalars['Int']['input']>;
  usage_limit?: InputMaybe<Scalars['Int']['input']>;
  usage_type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface User_Usage_Max_Fields {
  __typename?: 'user_usage_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  reset_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usage_count?: Maybe<Scalars['Int']['output']>;
  usage_limit?: Maybe<Scalars['Int']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "user_usage" */
export interface User_Usage_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  reset_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
  usage_type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface User_Usage_Min_Fields {
  __typename?: 'user_usage_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  reset_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usage_count?: Maybe<Scalars['Int']['output']>;
  usage_limit?: Maybe<Scalars['Int']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "user_usage" */
export interface User_Usage_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  reset_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
  usage_type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "user_usage" */
export interface User_Usage_Mutation_Response {
  __typename?: 'user_usage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Usage>;
}

/** on_conflict condition type for table "user_usage" */
export interface User_Usage_On_Conflict {
  constraint: User_Usage_Constraint;
  update_columns?: Array<User_Usage_Update_Column>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}

/** Ordering options when selecting data from "user_usage". */
export interface User_Usage_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  reset_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
  usage_type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: user_usage */
export interface User_Usage_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "user_usage" */
export type User_Usage_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'last_used_at'
  /** column name */
  | 'reset_at'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'usage_count'
  /** column name */
  | 'usage_limit'
  /** column name */
  | 'usage_type'
  /** column name */
  | 'user_id';

/** input type for updating data in table "user_usage" */
export interface User_Usage_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reset_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usage_count?: InputMaybe<Scalars['Int']['input']>;
  usage_limit?: InputMaybe<Scalars['Int']['input']>;
  usage_type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate stddev on columns */
export interface User_Usage_Stddev_Fields {
  __typename?: 'user_usage_stddev_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev() on columns of table "user_usage" */
export interface User_Usage_Stddev_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** aggregate stddev_pop on columns */
export interface User_Usage_Stddev_Pop_Fields {
  __typename?: 'user_usage_stddev_pop_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_pop() on columns of table "user_usage" */
export interface User_Usage_Stddev_Pop_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** aggregate stddev_samp on columns */
export interface User_Usage_Stddev_Samp_Fields {
  __typename?: 'user_usage_stddev_samp_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by stddev_samp() on columns of table "user_usage" */
export interface User_Usage_Stddev_Samp_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "user_usage" */
export interface User_Usage_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: User_Usage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface User_Usage_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reset_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usage_count?: InputMaybe<Scalars['Int']['input']>;
  usage_limit?: InputMaybe<Scalars['Int']['input']>;
  usage_type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate sum on columns */
export interface User_Usage_Sum_Fields {
  __typename?: 'user_usage_sum_fields';
  usage_count?: Maybe<Scalars['Int']['output']>;
  usage_limit?: Maybe<Scalars['Int']['output']>;
}

/** order by sum() on columns of table "user_usage" */
export interface User_Usage_Sum_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** update columns of table "user_usage" */
export type User_Usage_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'last_used_at'
  /** column name */
  | 'reset_at'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'usage_count'
  /** column name */
  | 'usage_limit'
  /** column name */
  | 'usage_type'
  /** column name */
  | 'user_id';

export interface User_Usage_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Usage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Usage_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Usage_Bool_Exp;
}

/** aggregate var_pop on columns */
export interface User_Usage_Var_Pop_Fields {
  __typename?: 'user_usage_var_pop_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by var_pop() on columns of table "user_usage" */
export interface User_Usage_Var_Pop_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** aggregate var_samp on columns */
export interface User_Usage_Var_Samp_Fields {
  __typename?: 'user_usage_var_samp_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by var_samp() on columns of table "user_usage" */
export interface User_Usage_Var_Samp_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** aggregate variance on columns */
export interface User_Usage_Variance_Fields {
  __typename?: 'user_usage_variance_fields';
  usage_count?: Maybe<Scalars['Float']['output']>;
  usage_limit?: Maybe<Scalars['Float']['output']>;
}

/** order by variance() on columns of table "user_usage" */
export interface User_Usage_Variance_Order_By {
  usage_count?: InputMaybe<Order_By>;
  usage_limit?: InputMaybe<Order_By>;
}

/** columns and relationships of "users" */
export interface Users {
  __typename?: 'users';
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversations_aggregate: Conversations_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  menus: Array<Menus>;
  /** An aggregate relationship */
  menus_aggregate: Menus_Aggregate;
  /** An array relationship */
  pairings: Array<Pairings>;
  /** An aggregate relationship */
  pairings_aggregate: Pairings_Aggregate;
  /** An array relationship */
  referral_codes: Array<Referral_Codes>;
  /** An aggregate relationship */
  referral_codes_aggregate: Referral_Codes_Aggregate;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  role: User_Role_Enum;
  /** An array relationship */
  sources: Array<Sources>;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_api_keys: Array<User_Api_Keys>;
  /** An aggregate relationship */
  user_api_keys_aggregate: User_Api_Keys_Aggregate;
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>;
  /** An array relationship */
  user_profiles: Array<User_Profiles>;
  /** An aggregate relationship */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** An array relationship */
  user_referrals: Array<User_Referrals>;
  /** An aggregate relationship */
  user_referrals_aggregate: User_Referrals_Aggregate;
  /** An object relationship */
  user_role: User_Role;
  /** An array relationship */
  user_usages: Array<User_Usage>;
  /** An aggregate relationship */
  user_usages_aggregate: User_Usage_Aggregate;
  /** An array relationship */
  verification_codes: Array<Verification_Codes>;
  /** An aggregate relationship */
  verification_codes_aggregate: Verification_Codes_Aggregate;
}


/** columns and relationships of "users" */
export interface UsersConversationsArgs {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersConversations_AggregateArgs {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersMenusArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersMenus_AggregateArgs {
  distinct_on?: InputMaybe<Array<Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menus_Order_By>>;
  where?: InputMaybe<Menus_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersPairingsArgs {
  distinct_on?: InputMaybe<Array<Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairings_Order_By>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersPairings_AggregateArgs {
  distinct_on?: InputMaybe<Array<Pairings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pairings_Order_By>>;
  where?: InputMaybe<Pairings_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersReferral_CodesArgs {
  distinct_on?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referral_Codes_Order_By>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersReferral_Codes_AggregateArgs {
  distinct_on?: InputMaybe<Array<Referral_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referral_Codes_Order_By>>;
  where?: InputMaybe<Referral_Codes_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersRefresh_TokensArgs {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersRefresh_Tokens_AggregateArgs {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersSourcesArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersSources_AggregateArgs {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_Api_KeysArgs {
  distinct_on?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Api_Keys_Order_By>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_Api_Keys_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Api_Keys_Order_By>>;
  where?: InputMaybe<User_Api_Keys_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_ProfilesArgs {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_Profiles_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_ReferralsArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_Referrals_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referrals_Order_By>>;
  where?: InputMaybe<User_Referrals_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_UsagesArgs {
  distinct_on?: InputMaybe<Array<User_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Usage_Order_By>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersUser_Usages_AggregateArgs {
  distinct_on?: InputMaybe<Array<User_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Usage_Order_By>>;
  where?: InputMaybe<User_Usage_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersVerification_CodesArgs {
  distinct_on?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Codes_Order_By>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}


/** columns and relationships of "users" */
export interface UsersVerification_Codes_AggregateArgs {
  distinct_on?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Codes_Order_By>>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}

/** aggregated selection of "users" */
export interface Users_Aggregate {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
}

export interface Users_Aggregate_Bool_Exp {
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
}

export interface Users_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "users" */
export interface Users_Aggregate_Fields {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
}


/** aggregate fields of "users" */
export interface Users_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "users" */
export interface Users_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
}

/** input type for inserting array relation for remote table "users" */
export interface Users_Arr_Rel_Insert_Input {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface Users_Bool_Exp {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  conversations?: InputMaybe<Conversations_Bool_Exp>;
  conversations_aggregate?: InputMaybe<Conversations_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  menus?: InputMaybe<Menus_Bool_Exp>;
  menus_aggregate?: InputMaybe<Menus_Aggregate_Bool_Exp>;
  pairings?: InputMaybe<Pairings_Bool_Exp>;
  pairings_aggregate?: InputMaybe<Pairings_Aggregate_Bool_Exp>;
  referral_codes?: InputMaybe<Referral_Codes_Bool_Exp>;
  referral_codes_aggregate?: InputMaybe<Referral_Codes_Aggregate_Bool_Exp>;
  refresh_tokens?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  refresh_tokens_aggregate?: InputMaybe<Refresh_Tokens_Aggregate_Bool_Exp>;
  role?: InputMaybe<User_Role_Enum_Comparison_Exp>;
  sources?: InputMaybe<Sources_Bool_Exp>;
  sources_aggregate?: InputMaybe<Sources_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_api_keys?: InputMaybe<User_Api_Keys_Bool_Exp>;
  user_api_keys_aggregate?: InputMaybe<User_Api_Keys_Aggregate_Bool_Exp>;
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>;
  user_profiles?: InputMaybe<User_Profiles_Bool_Exp>;
  user_profiles_aggregate?: InputMaybe<User_Profiles_Aggregate_Bool_Exp>;
  user_referrals?: InputMaybe<User_Referrals_Bool_Exp>;
  user_referrals_aggregate?: InputMaybe<User_Referrals_Aggregate_Bool_Exp>;
  user_role?: InputMaybe<User_Role_Bool_Exp>;
  user_usages?: InputMaybe<User_Usage_Bool_Exp>;
  user_usages_aggregate?: InputMaybe<User_Usage_Aggregate_Bool_Exp>;
  verification_codes?: InputMaybe<Verification_Codes_Bool_Exp>;
  verification_codes_aggregate?: InputMaybe<Verification_Codes_Aggregate_Bool_Exp>;
}

/** unique or primary key constraints on table "users" */
export type Users_Constraint =
  /** unique or primary key constraint on columns "email" */
  | 'users_email_key'
  /** unique or primary key constraint on columns "id" */
  | 'users_pkey';

/** input type for inserting data into table "users" */
export interface Users_Insert_Input {
  conversations?: InputMaybe<Conversations_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  menus?: InputMaybe<Menus_Arr_Rel_Insert_Input>;
  pairings?: InputMaybe<Pairings_Arr_Rel_Insert_Input>;
  referral_codes?: InputMaybe<Referral_Codes_Arr_Rel_Insert_Input>;
  refresh_tokens?: InputMaybe<Refresh_Tokens_Arr_Rel_Insert_Input>;
  role?: InputMaybe<User_Role_Enum>;
  sources?: InputMaybe<Sources_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_api_keys?: InputMaybe<User_Api_Keys_Arr_Rel_Insert_Input>;
  user_profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
  user_profiles?: InputMaybe<User_Profiles_Arr_Rel_Insert_Input>;
  user_referrals?: InputMaybe<User_Referrals_Arr_Rel_Insert_Input>;
  user_role?: InputMaybe<User_Role_Obj_Rel_Insert_Input>;
  user_usages?: InputMaybe<User_Usage_Arr_Rel_Insert_Input>;
  verification_codes?: InputMaybe<Verification_Codes_Arr_Rel_Insert_Input>;
}

/** aggregate max on columns */
export interface Users_Max_Fields {
  __typename?: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by max() on columns of table "users" */
export interface Users_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Users_Min_Fields {
  __typename?: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
}

/** order by min() on columns of table "users" */
export interface Users_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "users" */
export interface Users_Mutation_Response {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
}

/** input type for inserting object relation for remote table "users" */
export interface Users_Obj_Rel_Insert_Input {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
}

/** on_conflict condition type for table "users" */
export interface Users_On_Conflict {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
}

/** Ordering options when selecting data from "users". */
export interface Users_Order_By {
  conversations_aggregate?: InputMaybe<Conversations_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  menus_aggregate?: InputMaybe<Menus_Aggregate_Order_By>;
  pairings_aggregate?: InputMaybe<Pairings_Aggregate_Order_By>;
  referral_codes_aggregate?: InputMaybe<Referral_Codes_Aggregate_Order_By>;
  refresh_tokens_aggregate?: InputMaybe<Refresh_Tokens_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  sources_aggregate?: InputMaybe<Sources_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_api_keys_aggregate?: InputMaybe<User_Api_Keys_Aggregate_Order_By>;
  user_profile?: InputMaybe<User_Profiles_Order_By>;
  user_profiles_aggregate?: InputMaybe<User_Profiles_Aggregate_Order_By>;
  user_referrals_aggregate?: InputMaybe<User_Referrals_Aggregate_Order_By>;
  user_role?: InputMaybe<User_Role_Order_By>;
  user_usages_aggregate?: InputMaybe<User_Usage_Aggregate_Order_By>;
  verification_codes_aggregate?: InputMaybe<Verification_Codes_Aggregate_Order_By>;
}

/** primary key columns input for table: users */
export interface Users_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "users" */
export type Users_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'email'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "users" */
export interface Users_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<User_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** Streaming cursor of the table "users" */
export interface Users_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Users_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<User_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** update columns of table "users" */
export type Users_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'email'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updated_at';

export interface Users_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface Uuid_Comparison_Exp {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
}

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export interface Vector_Comparison_Exp {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
}

/** columns and relationships of "verification_codes" */
export interface Verification_Codes {
  __typename?: 'verification_codes';
  code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
}

/** aggregated selection of "verification_codes" */
export interface Verification_Codes_Aggregate {
  __typename?: 'verification_codes_aggregate';
  aggregate?: Maybe<Verification_Codes_Aggregate_Fields>;
  nodes: Array<Verification_Codes>;
}

export interface Verification_Codes_Aggregate_Bool_Exp {
  count?: InputMaybe<Verification_Codes_Aggregate_Bool_Exp_Count>;
}

export interface Verification_Codes_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Verification_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "verification_codes" */
export interface Verification_Codes_Aggregate_Fields {
  __typename?: 'verification_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Verification_Codes_Max_Fields>;
  min?: Maybe<Verification_Codes_Min_Fields>;
}


/** aggregate fields of "verification_codes" */
export interface Verification_Codes_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Verification_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "verification_codes" */
export interface Verification_Codes_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Verification_Codes_Max_Order_By>;
  min?: InputMaybe<Verification_Codes_Min_Order_By>;
}

/** input type for inserting array relation for remote table "verification_codes" */
export interface Verification_Codes_Arr_Rel_Insert_Input {
  data: Array<Verification_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Verification_Codes_On_Conflict>;
}

/** Boolean expression to filter rows from the table "verification_codes". All fields are combined with a logical 'AND'. */
export interface Verification_Codes_Bool_Exp {
  _and?: InputMaybe<Array<Verification_Codes_Bool_Exp>>;
  _not?: InputMaybe<Verification_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Verification_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "verification_codes" */
export type Verification_Codes_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'verification_codes_pkey';

/** input type for inserting data into table "verification_codes" */
export interface Verification_Codes_Insert_Input {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Verification_Codes_Max_Fields {
  __typename?: 'verification_codes_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "verification_codes" */
export interface Verification_Codes_Max_Order_By {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Verification_Codes_Min_Fields {
  __typename?: 'verification_codes_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "verification_codes" */
export interface Verification_Codes_Min_Order_By {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "verification_codes" */
export interface Verification_Codes_Mutation_Response {
  __typename?: 'verification_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Verification_Codes>;
}

/** on_conflict condition type for table "verification_codes" */
export interface Verification_Codes_On_Conflict {
  constraint: Verification_Codes_Constraint;
  update_columns?: Array<Verification_Codes_Update_Column>;
  where?: InputMaybe<Verification_Codes_Bool_Exp>;
}

/** Ordering options when selecting data from "verification_codes". */
export interface Verification_Codes_Order_By {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: verification_codes */
export interface Verification_Codes_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "verification_codes" */
export type Verification_Codes_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "verification_codes" */
export interface Verification_Codes_Set_Input {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "verification_codes" */
export interface Verification_Codes_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Verification_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Verification_Codes_Stream_Cursor_Value_Input {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "verification_codes" */
export type Verification_Codes_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Verification_Codes_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Verification_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Verification_Codes_Bool_Exp;
}

/** Consolidated wine data from products and product_details tables in JSONB format, structured according to Python model definitions. Key fields like year, wine_type, and country are included as direct columns for efficient querying. */
export interface Wine_Products {
  __typename?: 'wine_products';
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  product_embedding?: Maybe<Product_Embeddings>;
  /** An object relationship */
  source?: Maybe<Sources>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier?: Maybe<Suppliers>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
}


/** Consolidated wine data from products and product_details tables in JSONB format, structured according to Python model definitions. Key fields like year, wine_type, and country are included as direct columns for efficient querying. */
export interface Wine_ProductsDataArgs {
  path?: InputMaybe<Scalars['String']['input']>;
}

/** aggregated selection of "wine_products" */
export interface Wine_Products_Aggregate {
  __typename?: 'wine_products_aggregate';
  aggregate?: Maybe<Wine_Products_Aggregate_Fields>;
  nodes: Array<Wine_Products>;
}

export interface Wine_Products_Aggregate_Bool_Exp {
  count?: InputMaybe<Wine_Products_Aggregate_Bool_Exp_Count>;
}

export interface Wine_Products_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Wine_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wine_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** aggregate fields of "wine_products" */
export interface Wine_Products_Aggregate_Fields {
  __typename?: 'wine_products_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Wine_Products_Max_Fields>;
  min?: Maybe<Wine_Products_Min_Fields>;
}


/** aggregate fields of "wine_products" */
export interface Wine_Products_Aggregate_FieldsCountArgs {
  columns?: InputMaybe<Array<Wine_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
}

/** order by aggregate values of table "wine_products" */
export interface Wine_Products_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wine_Products_Max_Order_By>;
  min?: InputMaybe<Wine_Products_Min_Order_By>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Wine_Products_Append_Input {
  data?: InputMaybe<Scalars['jsonb']['input']>;
}

/** input type for inserting array relation for remote table "wine_products" */
export interface Wine_Products_Arr_Rel_Insert_Input {
  data: Array<Wine_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wine_Products_On_Conflict>;
}

/** Boolean expression to filter rows from the table "wine_products". All fields are combined with a logical 'AND'. */
export interface Wine_Products_Bool_Exp {
  _and?: InputMaybe<Array<Wine_Products_Bool_Exp>>;
  _not?: InputMaybe<Wine_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Wine_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product_embedding?: InputMaybe<Product_Embeddings_Bool_Exp>;
  source?: InputMaybe<Sources_Bool_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Suppliers_Bool_Exp>;
  supplier_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "wine_products" */
export type Wine_Products_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'wine_products_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Wine_Products_Delete_At_Path_Input {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Wine_Products_Delete_Elem_Input {
  data?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Wine_Products_Delete_Key_Input {
  data?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting data into table "wine_products" */
export interface Wine_Products_Insert_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  product_embedding?: InputMaybe<Product_Embeddings_Obj_Rel_Insert_Input>;
  source?: InputMaybe<Sources_Obj_Rel_Insert_Input>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Suppliers_Obj_Rel_Insert_Input>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** aggregate max on columns */
export interface Wine_Products_Max_Fields {
  __typename?: 'wine_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by max() on columns of table "wine_products" */
export interface Wine_Products_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** aggregate min on columns */
export interface Wine_Products_Min_Fields {
  __typename?: 'wine_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
}

/** order by min() on columns of table "wine_products" */
export interface Wine_Products_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** response of any mutation on the table "wine_products" */
export interface Wine_Products_Mutation_Response {
  __typename?: 'wine_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wine_Products>;
}

/** input type for inserting object relation for remote table "wine_products" */
export interface Wine_Products_Obj_Rel_Insert_Input {
  data: Wine_Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wine_Products_On_Conflict>;
}

/** on_conflict condition type for table "wine_products" */
export interface Wine_Products_On_Conflict {
  constraint: Wine_Products_Constraint;
  update_columns?: Array<Wine_Products_Update_Column>;
  where?: InputMaybe<Wine_Products_Bool_Exp>;
}

/** Ordering options when selecting data from "wine_products". */
export interface Wine_Products_Order_By {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_embedding?: InputMaybe<Product_Embeddings_Order_By>;
  source?: InputMaybe<Sources_Order_By>;
  source_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Suppliers_Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: wine_products */
export interface Wine_Products_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Wine_Products_Prepend_Input {
  data?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "wine_products" */
export type Wine_Products_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'source_id'
  /** column name */
  | 'status'
  /** column name */
  | 'supplier_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "wine_products" */
export interface Wine_Products_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "wine_products" */
export interface Wine_Products_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Wine_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Wine_Products_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "wine_products" */
export type Wine_Products_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'source_id'
  /** column name */
  | 'status'
  /** column name */
  | 'supplier_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export interface Wine_Products_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Wine_Products_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Wine_Products_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Wine_Products_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Wine_Products_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Wine_Products_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wine_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wine_Products_Bool_Exp;
}

export type GetMenusQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<Menus_Bool_Exp>;
}>;


export type GetMenusQuery = { __typename?: 'query_root', menus: Array<{ __typename?: 'menus', id: string, name: string, description?: string | null, price?: any | null, tags?: Array<string> | null, status: string, pairing_id?: string | null, pairing?: { __typename?: 'pairings', id: string, user_id: string, params: any, status: any, error?: string | null, analysis_data?: any | null, created_at: string, updated_at: string } | null }>, menus_aggregate: { __typename?: 'menus_aggregate', aggregate?: { __typename?: 'menus_aggregate_fields', count: number } | null } };

export type GetReferralCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralCodesQuery = { __typename?: 'query_root', referral_codes: Array<{ __typename?: 'referral_codes', id: string, code: string, created_by?: string | null, is_admin_created: boolean, created_at: string, updated_at: string, user_referrals_aggregate: { __typename?: 'user_referrals_aggregate', aggregate?: { __typename?: 'user_referrals_aggregate_fields', count: number } | null } }> };

export type GetSuppliersAndSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersAndSourcesQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'suppliers', id: string, name: string, sources: Array<{ __typename?: 'sources', id: string, name: string }> }> };

export type GetConversationsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetConversationsSubscription = { __typename?: 'subscription_root', conversations: Array<{ __typename?: 'conversations', id: string, title: string, created_at: string, messages: Array<{ __typename?: 'messages', created_at: string }> }> };

export type OnMessagesUpdatedSubscriptionVariables = Exact<{
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type OnMessagesUpdatedSubscription = { __typename?: 'subscription_root', messages: Array<{ __typename?: 'messages', id: string, conversation_id: string, parent_id?: string | null, content: any, role: string, params?: any | null, created_at: string, updated_at: string }> };


export const GetMenusDocument = gql`
    query GetMenus($limit: Int!, $offset: Int!, $where: menus_bool_exp) {
  menus(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {created_at: desc}
  ) {
    id
    name
    description
    price
    tags
    status
    pairing_id
    pairing {
      id
      user_id
      params
      status
      error
      analysis_data
      created_at
      updated_at
    }
  }
  menus_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMenusQuery__
 *
 * To run a query within a React component, call `useGetMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenusQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMenusQuery(baseOptions: Apollo.QueryHookOptions<GetMenusQuery, GetMenusQueryVariables> & ({ variables: GetMenusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenusQuery, GetMenusQueryVariables>(GetMenusDocument, options);
      }
export function useGetMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenusQuery, GetMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenusQuery, GetMenusQueryVariables>(GetMenusDocument, options);
        }
export function useGetMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenusQuery, GetMenusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenusQuery, GetMenusQueryVariables>(GetMenusDocument, options);
        }
export type GetMenusQueryHookResult = ReturnType<typeof useGetMenusQuery>;
export type GetMenusLazyQueryHookResult = ReturnType<typeof useGetMenusLazyQuery>;
export type GetMenusSuspenseQueryHookResult = ReturnType<typeof useGetMenusSuspenseQuery>;
export type GetMenusQueryResult = Apollo.QueryResult<GetMenusQuery, GetMenusQueryVariables>;
export const GetReferralCodesDocument = gql`
    query GetReferralCodes {
  referral_codes(order_by: {created_at: desc}) {
    id
    code
    created_by
    is_admin_created
    created_at
    updated_at
    user_referrals_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetReferralCodesQuery__
 *
 * To run a query within a React component, call `useGetReferralCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferralCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetReferralCodesQuery, GetReferralCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralCodesQuery, GetReferralCodesQueryVariables>(GetReferralCodesDocument, options);
      }
export function useGetReferralCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralCodesQuery, GetReferralCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralCodesQuery, GetReferralCodesQueryVariables>(GetReferralCodesDocument, options);
        }
export function useGetReferralCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferralCodesQuery, GetReferralCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferralCodesQuery, GetReferralCodesQueryVariables>(GetReferralCodesDocument, options);
        }
export type GetReferralCodesQueryHookResult = ReturnType<typeof useGetReferralCodesQuery>;
export type GetReferralCodesLazyQueryHookResult = ReturnType<typeof useGetReferralCodesLazyQuery>;
export type GetReferralCodesSuspenseQueryHookResult = ReturnType<typeof useGetReferralCodesSuspenseQuery>;
export type GetReferralCodesQueryResult = Apollo.QueryResult<GetReferralCodesQuery, GetReferralCodesQueryVariables>;
export const GetSuppliersAndSourcesDocument = gql`
    query GetSuppliersAndSources {
  suppliers {
    id
    name
    sources(where: {parse_status: {_eq: "completed"}}) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSuppliersAndSourcesQuery__
 *
 * To run a query within a React component, call `useGetSuppliersAndSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersAndSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersAndSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuppliersAndSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>(GetSuppliersAndSourcesDocument, options);
      }
export function useGetSuppliersAndSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>(GetSuppliersAndSourcesDocument, options);
        }
export function useGetSuppliersAndSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>(GetSuppliersAndSourcesDocument, options);
        }
export type GetSuppliersAndSourcesQueryHookResult = ReturnType<typeof useGetSuppliersAndSourcesQuery>;
export type GetSuppliersAndSourcesLazyQueryHookResult = ReturnType<typeof useGetSuppliersAndSourcesLazyQuery>;
export type GetSuppliersAndSourcesSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersAndSourcesSuspenseQuery>;
export type GetSuppliersAndSourcesQueryResult = Apollo.QueryResult<GetSuppliersAndSourcesQuery, GetSuppliersAndSourcesQueryVariables>;
export const GetConversationsDocument = gql`
    subscription GetConversations {
  conversations {
    id
    title
    created_at
    messages(order_by: {created_at: desc}, limit: 1) {
      created_at
    }
  }
}
    `;

/**
 * __useGetConversationsSubscription__
 *
 * To run a query within a React component, call `useGetConversationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetConversationsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetConversationsSubscription, GetConversationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetConversationsSubscription, GetConversationsSubscriptionVariables>(GetConversationsDocument, options);
      }
export type GetConversationsSubscriptionHookResult = ReturnType<typeof useGetConversationsSubscription>;
export type GetConversationsSubscriptionResult = Apollo.SubscriptionResult<GetConversationsSubscription>;
export const OnMessagesUpdatedDocument = gql`
    subscription onMessagesUpdated($conversation_id: uuid) {
  messages(
    where: {conversation_id: {_eq: $conversation_id}}
    order_by: {created_at: asc}
  ) {
    id
    conversation_id
    parent_id
    content
    role
    params
    created_at
    updated_at
  }
}
    `;

/**
 * __useOnMessagesUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMessagesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessagesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessagesUpdatedSubscription({
 *   variables: {
 *      conversation_id: // value for 'conversation_id'
 *   },
 * });
 */
export function useOnMessagesUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnMessagesUpdatedSubscription, OnMessagesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMessagesUpdatedSubscription, OnMessagesUpdatedSubscriptionVariables>(OnMessagesUpdatedDocument, options);
      }
export type OnMessagesUpdatedSubscriptionHookResult = ReturnType<typeof useOnMessagesUpdatedSubscription>;
export type OnMessagesUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnMessagesUpdatedSubscription>;